import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
import { Alert } from "react-bootstrap";
import { Check, X } from "lucide-react";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Typography,
  InputAdornment,
  IconButton,
  Tooltip,
  Popover as PopoverMui,
} from "@mui/material";
import { ChevronDown, Plus } from "lucide-react";
import RackBinModal from "../../../components/models/rack-bin-modal";
import {
  Link,
  useNavigate,
  useParams,
  useBlocker,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, TextField, Popover } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { roleTypes } from "../../../data/roleType";
import { RotatingLines } from "react-loader-spinner";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import DatePickerField from "../../../components/input/date-picker-field";
import SerialNumberPanel from "../../../components/models/serial-number-panel";

const OrderRequestEdit = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [animatingRows, setAnimatingRows] = useState(new Set());
  const [movingProducts, setMovingProducts] = useState(new Set());
  const [dragPopoverAnchor, setDragPopoverAnchor] = useState(null);
  const [dragPopoverOpen, setDragPopoverOpen] = useState(false);
  const alertRefProduct = useRef(null);
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState({});

  const [sidePanelWidth, setSidePanelWidth] = useState(480);
 
  const [decodedToken, setDecodedToken] = useState();
  const [vendors, setVendors] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [warehouseId, setWarehouseId] = useState(null);
  const [rackOptions, setRackOptions] = useState([]);
  const [allRacks, setAllRacks] = useState([]);
  const [oldOrderProducts, setOldOrderProducts] = useState([]);
  const [vendorId, setVendorId] = useState("all");
  const [isHovered, setIsHovered] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const token = localStorage.getItem("coyote-token");
  const [showPartialWarning, setShowPartialWarning] = useState(false);
  const [fromStatusChange, setFromStatusChange] = useState(false);
  const [fromReceiveInFull, setFromReceiveInFull] = useState(false);

  const [newlyImportedProducts, setNewlyImportedProducts] = useState([]);
  const [backendOrderProducts, setBackendOrderProducts] = useState([]);
  const [totalBackendRecords, setTotalBackendRecords] = useState(0);

  const [products, setProducts] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingOrderProducts, setLoadingOrderProducts] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const [orderPagination, setOrderPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [globalFilter, setGlobalFilter] = useState("");
  const [orderGlobalFilter, setOrderGlobalFilter] = useState("");
  const permissions = useSelector(SettingSelector.set_permissions);
  const hasImportUpdatePermission = permissions?.purchase_order.update === true;
  const [selectedProductKeys, setSelectedProductKeys] = useState(new Set());
  const [selectedProductsData, setSelectedProductsData] = useState(new Map());
  const warehouseHasCreatePermission = permissions?.warehouse?.create === true;

  const [showSerialModal, setShowSerialModal] = useState(false);
  const [serialItems, setSerialItems] = useState([]);
  const [pendingSerialUpdate, setPendingSerialUpdate] = useState(null);
  const [serialNumbers, setSerialNumbers] = useState({});

  const [activePanel, setActivePanel] = useState("none");
  const showGeneralProductsPanel = activePanel === "general";
  const isTable3Open = activePanel === "requested";
  const isRightPanelOpen = activePanel !== "none";

  const [gpSearchText, setGpSearchText] = useState("");
  const [gpProducts, setGpProducts] = useState([]);
  const [gpTotal, setGpTotal] = useState(0);
  const [gpNextOffset, setGpNextOffset] = useState(null);
  const [gpOffset, setGpOffset] = useState(0);
  const [gpLoadingInitial, setGpLoadingInitial] = useState(false);
  const [gpLoadingMore, setGpLoadingMore] = useState(false);
  const [gpSortConfig, setGpSortConfig] = useState({ key: "productName", direction: "asc" });
  const [gpSelectedJobId, setGpSelectedJobId] = useState(null);
  const [gpSelectedSystemId, setGpSelectedSystemId] = useState(null);
  const [gpSelectedPhaseId, setGpSelectedPhaseId] = useState(null);
  const [gpSystemOptions, setGpSystemOptions] = useState([]);
  const [gpPhaseOptions, setGpPhaseOptions] = useState([]);
  const [bulkJobId, setBulkJobId] = useState(null);
  const [bulkSystemId, setBulkSystemId] = useState(null);
  const [bulkPhaseId, setBulkPhaseId] = useState(null);
  const [bulkSystemOptions, setBulkSystemOptions] = useState([]);
  const [bulkPhaseOptions, setBulkPhaseOptions] = useState([]);
  const [gpLoadingSystems, setGpLoadingSystems] = useState(false);
  const [gpSelectedProducts, setGpSelectedProducts] = useState([]);
  const [gpValidationErrors, setGpValidationErrors] = useState({});
  const [gpOptionsJob, setGpOptionsJob] = useState([]);
  const [gpViewItem, setGpViewItem] = useState(null);
  const [gpViewModal, setGpViewModal] = useState(false);
  const gpRequestIdRef = useRef(0);
  const GP_LIMIT = 20;

  const [leftWidth, setLeftWidth] = useState(50);
  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef(null);

  const [showRackBinModal, setShowRackBinModal] = useState(false);
  const [selectedRackOrderItem, setSelectedRackOrderItem] = useState(null);

  const startResizing = useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);
  const stopResizing = useCallback(() => setIsResizing(false), []);
  const resize = useCallback(
    (e) => {
      if (isResizing && containerRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const newWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;
        if (newWidth >= 32 && newWidth <= 85) setLeftWidth(newWidth);
      }
    },
    [isResizing],
  );

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  useEffect(() => {
    if (location.state?.fromStatusChange) {
      if (location.state?.selectedStatus === "Partially Received" || location.state?.selectedStatus === "Received in Full") {
        setShowPartialWarning(true);
        setFromStatusChange(true);
        setFromReceiveInFull(true);
      }
   
    }
  }, [location.state]);

  const [alert, setAlert] = useState({ message: "", type: "", show: false, alertFor: "" });
  const [selectedData, setSelectedData] = useState();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [initialFormValues, setInitialFormValues] = useState(null);
  const [jobSystemsPhasesMap, setJobSystemsPhasesMap] = useState({});

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname,
  );

  const createProductKey = (product) =>
    `${product.product_id}-${product.product_request_id}-${product.job_id}-${product.system_id}-${product.phase_id}`;

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(true);
      setPendingNavigation(() => blocker.proceed);
    }
  }, [blocker.state]);

  const handleDiscardChanges = useCallback(() => {
    if (blocker.state === "blocked") {
      setHasUnsavedChanges(false);
      setShowDiscardModal(false);
      if (pendingNavigation) {
        pendingNavigation();
        setPendingNavigation(null);
      } else if (blocker.proceed) blocker.proceed();
    }
  }, [blocker.state, pendingNavigation, blocker]);

  const handleCancelDiscard = useCallback(() => {
    if (blocker.state === "blocked") blocker.reset();
    setShowDiscardModal(false);
    setPendingNavigation(null);
  }, [blocker.state, blocker]);

  const [fieldSubmitOrderItem, setFieldSubmitOrderItem] = useState({ field: "", id: "" });
  const [successOrderItemSubmit, setSuccessOrderItemSubmit] = useState({ field: "", id: "" });
  const [failOrderItemSubmit, setFailOrderItemSubmit] = useState({ field: "", id: "" });

  const checkForUnsavedChanges = useCallback(() => {
    if (!initialFormValues || !selectedData) return false;
    const formValuesChanged =
      initialFormValues.date !== selectedData.date ||
      initialFormValues.poNumber !== selectedData.poNumber ||
      initialFormValues.warehouseId !== selectedData.warehouseId ||
      initialFormValues.shipTo !== selectedData.shipTo;
    const hasNewProducts = newlyImportedProducts.length > 0;
    return formValuesChanged || hasNewProducts;
  }, [initialFormValues, selectedData, newlyImportedProducts]);

  useEffect(() => {
    const hasChanges = checkForUnsavedChanges();
    setHasUnsavedChanges(hasChanges);
  }, [checkForUnsavedChanges]);

  const generateSearchableText = (item) => {
    return [
      item.name || item.product_name || item.productName,
      item.manufacturer_name || item.manufacturerName,
      item.model,
      item.sku,
      item.job_name || item.jobName,
      item.system_name || item.systemName,
      item.phase_name || item.phaseName,
      item.site_name || item.siteName,
      item.description,
      item.searchable_text || "",
      item.phaseNames || item.phase_names || "",
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  };

  const getExcludedProductIds = () => {
    const allOrderProducts = [...newlyImportedProducts, ...backendOrderProducts];
    return allOrderProducts.map((p) => ({
      product_id: p.product_id,
      product_request_id: p.product_request_id,
      system_id: p.system_id,
      phase_id: p.phase_id,
      job_id: p.job_id,
    }));
  };

  const filterProducts = (products, searchValue) => {
    if (!searchValue || searchValue.trim() === "") return products;
    const searchWords = searchValue.toLowerCase().trim().split(/\s+/);

    return products.filter((product) => {
      const textToSearch = [
        product.name, product.product_name, product.manufacturer_name,
        product.model, product.sku,
        product.job_name, product.system_name,
        product.phase_name, 
        product.description,
        product.searchable_text || "", 
        product.productName,
      ]
        .filter(Boolean).join(" ").toLowerCase();
      return searchWords.every((word) => textToSearch.includes(word));
    });
  };

  const getPaginatedData = (data, pageIndex, pageSize) => {
    const startIndex = pageIndex * pageSize;
    return data.slice(startIndex, startIndex + pageSize);
  };

  const enhancedOrderProducts = useMemo(() => {
    const allOrderProducts = [...newlyImportedProducts, ...backendOrderProducts];
    const filteredProducts = filterProducts(allOrderProducts, orderGlobalFilter);
    return getPaginatedData(filteredProducts, orderPagination.pageIndex, orderPagination.pageSize);
  }, [newlyImportedProducts, backendOrderProducts, orderGlobalFilter, orderPagination.pageIndex, orderPagination.pageSize]);

  const totalOrderRecords = useMemo(() => {
    const allOrderProducts = [...newlyImportedProducts, ...backendOrderProducts];
    return filterProducts(allOrderProducts, orderGlobalFilter).length;
  }, [newlyImportedProducts, backendOrderProducts, orderGlobalFilter]);

  const getOrderProducts = async (page = 0, limit = 10, search = "") => {
    try {
      setLoadingOrderProducts(true);
      const response = await axios.get(`${url.backendURL}order/${id}/detail/products`, {
        headers: { Authorization: `${token}` },
        params: { page: page + 1, limit, search },
      });
      const responseData = response.data.response;
      const mappedOrderItems = (responseData.data || []).map((data) => ({
        ...data,
        new_quantity: data.new_quantity || 0,
        old_quantity: data.received_quantity || 0,
        isFromBackend: true,
      }));
      setBackendOrderProducts(mappedOrderItems);
      setTotalBackendRecords(responseData.totalItems || 0);
    } catch (err) {
      handleError(err, "order-products");
    } finally {
      setLoadingOrderProducts(false);
    }
  };

  const [orderStatusReceived, setOrderStatusReceived] = useState(false);
  const [orderStatusCancelled, setOrderStatusCancelled] = useState(false);

  const handleBinAssign = async (rack, bin, containsSelectedProduct) => {
    if (!selectedRackOrderItem) return;

    const orderItemId =
      selectedRackOrderItem.order_item_id ?? selectedRackOrderItem.orderItemId;
    const newBinId = bin.id;

    const targetProductId = selectedRackOrderItem.product_id ?? selectedRackOrderItem.productId;
    const targetWarehouseId = selectedRackOrderItem.warehouse_id ?? warehouseId;

    const updater = (prev) =>
      prev.map((item) => {
        const itemId = item.order_item_id ?? item.orderItemId;
        const itemProductId = item.product_id ?? item.productId;
        const itemWarehouseId = item.warehouse_id ?? warehouseId;

        if (
          (orderItemId && itemId === orderItemId) ||
          (!orderItemId && createProductKey(item) === createProductKey(selectedRackOrderItem)) ||
          (itemProductId === targetProductId && itemWarehouseId === targetWarehouseId)
        ) {
          return {
            ...item,
            rack_id: newBinId,
            rack_id_parent: rack.rack_id,
            default_bin_id: newBinId,
            rack_name: rack.name,
            rack_number: rack.rack_number,
            row_number: bin.row_number,
            column_number: bin.column_number,
          };
        }
        return item;
      });

    const isFromSerialModal = selectedRackOrderItem?._fromSerialModal;

    setSerialItems((prev) =>
      prev.map((item) => {
        const itemId = item.order_item_id ?? item.orderItemId;
        const itemMatch = (orderItemId && itemId === orderItemId) ||
                        (!orderItemId && createProductKey(item) === createProductKey(selectedRackOrderItem));
        
        return itemMatch ? {
          ...item,
          rack_id: newBinId,
          rack_name: rack.name,
          rack_number: rack.rack_number,
          row_number: bin.row_number,
          column_number: bin.column_number,
        } : item;
      })
    );

    if (isFromSerialModal) {
      setShowRackBinModal(false);
      setSelectedRackOrderItem(null);
      return { success: true, message: "Location assigned successfully" };
    }

    if (orderItemId) {
      setBackendOrderProducts(updater);
      try {
        await axios.put(
          `${url.backendURL}order/${id}/item/${orderItemId}/field`,
          { rack_id: newBinId },
          { headers: { Authorization: `${token}` } },
        );
        return { success: true, message: "Location updated successfully" };
      } catch (err) {
        const errMsg = err?.response?.data?.message || "Failed to update location";
        return { success: false, message: errMsg };
      }
    } else {
      setNewlyImportedProducts(updater);
      setHasUnsavedChanges(true);
      setSelectedRackOrderItem((prev) => ({
        ...prev,
        rack_id: newBinId,
        rack_id_parent: rack.rack_id,
        default_bin_id: newBinId,
      }));
    }

    if (isFromSerialModal) {
      setShowRackBinModal(false);
      setSelectedRackOrderItem(null);
    } else {
      setSelectedRackOrderItem((prev) => ({
        ...prev,
        rack_id: newBinId,
        rack_id_parent: rack.rack_id,
        default_bin_id: newBinId,
      }));
    }
    return { success: true, message: "" };
  };

  const fetchRackOptions = async (wId) => {
    if (!wId) { setRackOptions([]); setAllRacks([]); return; }
    try {
      const response = await axios.get(`${url.backendURL}warehouse/${wId}/bins`, {
        headers: { Authorization: `${token}` },
      });
      const bins = response.data.response?.data || response.data.response || [];
      if (Array.isArray(bins)) {
        setRackOptions(
          bins.map((b) => ({
            value: b.id,
            label: `${b.rackName}${b.rackNumber ? " - " + b.rackNumber : ""} (R${b.rowNumber}C${b.columnNumber})`,
          })),
        );
      } else {
        setRackOptions([]);
      }
    } catch (err) {
      setRackOptions([]);
    }
  };

  const handleShowView = async (item) => {
    if (item) {
      setVendorId("all");
      setOrderStatusReceived(item.status === "Received in Full");
      setOrderStatusCancelled(item.status === "Cancelled");
      const formData = {
        id: item.id || null,
        shipTo: item.ship_to || null,
        poNumber: item.po_number || null,
        vendorId: item.vendor_id || "",
        warehouseId: item?.warehouse_id,
        warehouseName: item?.warehouse_name,
        vendorName: item?.vendor_name,
        date: item.date || "",
        orderItems: item.order_items?.map((data) => ({
          id: data.product_id,
          productRequestId: data.product_request_id,
          name: data.name,
          description: data.description,
          warehouse: data.warehouse_name,
          jobName: data.job_name,
          siteName: data.site_name,
          systemName: data.system_name,
          phaseName: data.phase_name,
          quantity: data.quantity,
          receivedQuantity: data.received_quantity,
          oldQuantity: data.received_quantity,
          newQuantity: 0,
          status: data.status,
          rate: data.rate,
          model: data.model,
          orderItemId: data.order_item_id,
          rack_id: data.rack_id,
          inventory_type: data.inventory_type,
        })),
      };
      setSelectedData(formData);
      setInitialFormValues({
        date: item.date || "",
        poNumber: item.po_number || null,
        vendorId: item.vendor_id || "all",
        warehouseId: item?.warehouse_id,
        shipTo: item.ship_to || null,
      });
      const mappedOrderItems = item.order_items?.map((data) => ({
        ...data,
        new_quantity: 0,
        old_quantity: data.received_quantity,
        isFromBackend: true,
        rack_id: data.rack_id || null,
        inventory_type: data.inventory_type || "None",
      }));
      setBackendOrderProducts(mappedOrderItems || []);
      setOldOrderProducts(JSON.parse(JSON.stringify(mappedOrderItems || [])));
      setLoader(false);
      setWarehouseId(item?.warehouse_id || null);
      fetchRackOptions(item?.warehouse_id || null);
    }
  };

  const resetPaginationToFirst = () => {
    setOrderPagination({ pageIndex: 0, pageSize: orderPagination.pageSize });
  };

  const getOrder = async () => {
    try {
      const response = await axios.get(`${url.backendURL}order/${id}/detail`, {
        headers: { Authorization: `${token}` },
      });
      const productRequests = response.data.response.data;
      setTotalBackendRecords(response.data.response.totalItems || 0);
      handleShowView(productRequests);
    } catch (err) {
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "information");
      setLoader(false);
      if (typeof err.response?.data?.error === "string" && err.response?.data?.error.includes("Invalid operation")) {
        setTimeout(() => navigate("/dashboard/app/purchase-order-list"), 5000);
      }
    }
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getWarehouses = async () => {
    try {
      const response = await axios.get(`${url.backendURL}warehouse/all/lists`, {
        headers: { Authorization: `${token}` },
      });
      setWarehouses(response.data.response.data);
    } catch (err) {
      handleError(err, "user-edit");
    }
  };

  const getVendors = async () => {
    try {
      const response = await axios.get(`${url.backendURL}vendor/all/product-request`, {
        headers: { Authorization: `${token}` },
      });
      setVendors(response.data.response.data);
    } catch (err) {
      handleError(err, "order-add");
    }
  };

  const getAllVendors = async () => {
    try {
      const response = await axios.get(`${url.backendURL}vendor/all`, {
        headers: { Authorization: `${token}` },
      });
      setAllVendors(response.data.response.data);
    } catch (err) {
      handleError(err, "order-edit");
    }
  };

  const getActiveProductRequests = async (page = 0, limit = 10, search = "") => {
    try {
      setLoadingProducts(true);
      const excludedProducts = getExcludedProductIds();
      const response = await axios.post(
        `${url.backendURL}order/active-product-request`,
        { excludeProducts: excludedProducts },
        {
          headers: { Authorization: `${token}` },
          params: { page: page + 1, limit, search, vendorId: vendorId !== "all" ? vendorId : undefined },
        },
      );
      const responseData = response.data.response;
      const allOrderProducts = [...newlyImportedProducts, ...backendOrderProducts];
      const availableProducts = (responseData.data || []).filter(
        (product) =>
          !allOrderProducts.some(
            (op) =>
              op.product_id === product.product_id &&
              op.product_request_id === product.product_request_id &&
              (op.system_id === product.system_id || (op.system_id === null && product.system_id === null)) &&
              (op.phase_id === product.phase_id || (op.phase_id === null && product.phase_id === null)) &&
              (op.job_id === product.job_id || (op.job_id === null && product.job_id === null)),
          ),
      );
      setProducts(
        availableProducts.map((product) => ({
          ...product,
          isSelected: selectedProductKeys.has(createProductKey(product)),
        })),
      );
      setTotalRecords(responseData.total || 0);
    } catch (err) {
      try {
        const excludedProducts = getExcludedProductIds();
        const response = await axios.get(`${url.backendURL}order/active-product-request`, {
          headers: { Authorization: `${token}` },
          params: {
            page: page + 1, limit, search,
            vendorId: vendorId !== "all" ? vendorId : undefined,
            excludeProducts: JSON.stringify(excludedProducts),
          },
        });
        const responseData = response.data.response;
        const allOrderProducts = [...newlyImportedProducts, ...backendOrderProducts];
        const availableProducts = (responseData.data || []).filter(
          (product) =>
            !allOrderProducts.some(
              (op) =>
                op.product_id === product.product_id &&
                op.product_request_id === product.product_request_id &&
                op.system_id === product.system_id &&
                op.phase_id === product.phase_id,
            ),
        );
        setProducts(
          availableProducts.map((product) => ({
            ...product,
            isSelected: selectedProductKeys.has(createProductKey(product)),
          })),
        );
        setTotalRecords(responseData.total || 0);
      } catch (fallbackErr) {
        console.error("Fallback request also failed:", fallbackErr);
      }
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (token && decodedToken) {
      getActiveProductRequests(pagination.pageIndex, pagination.pageSize, globalFilter);
    }
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, vendorId, newlyImportedProducts, backendOrderProducts, token, decodedToken]);

  useEffect(() => {
    if (token && decodedToken) {
      const fetchData = async () => {
        await getVendors();
        await getAllVendors();
        await getWarehouses();
        await getOrder();
        setLoader(false);
      };
      fetchData();
    }
  }, [token, decodedToken]);

  const [validationErrors, setValidationErrors] = useState();

  const hasAnyProductMarkedReceived = useCallback(() => {
    const hasNewlyImportedReceived = newlyImportedProducts.some((p) => p.new_quantity > 0);
    const hasBackendProductReceived = backendOrderProducts.some((p) => p.new_quantity > 0);
    return hasNewlyImportedReceived || hasBackendProductReceived;
  }, [newlyImportedProducts, backendOrderProducts]);

  useEffect(() => {
    if (showPartialWarning && hasAnyProductMarkedReceived()) setShowPartialWarning(false);
  }, [showPartialWarning, hasAnyProductMarkedReceived]);

  const handleSerialSubmit = async (serials, itemRacks = {}) => {
    setShowSerialModal(false);
    setActivePanel("none");
    if (!pendingSerialUpdate) return;
    const { type, products: allReceiveProducts } = pendingSerialUpdate;

    if (type === "receiveAll") {
      setIsReceivingAll(true);
      try {
        await axios.put(
          `${url.backendURL}order/${id}/receive-all`,
          { serialNumbers: serials, racks: itemRacks },
          { headers: { Authorization: `${token}` } },
        );
        
        setAlert({
          message: "All products marked as received successfully",
          type: "success",
          show: true,
          alertFor: "order-add",
        });
        setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);
        await getOrder();
        await getOrderProducts(orderPagination.pageIndex, orderPagination.pageSize, orderGlobalFilter);
      } catch (err) {
        handleError(err, "order-add");
      } finally {
        setIsReceivingAll(false);
      }
    } else {
      const { orderItemId, intValue, productData, type: actionType } = pendingSerialUpdate;
      const effectiveOrderItemId = actionType === "full" ? productData.order_item_id : orderItemId;

      const payload = {
        serialNumbers: serials,
      };

      if (itemRacks[effectiveOrderItemId]) {
        payload.rack_id = itemRacks[effectiveOrderItemId];
      }

      try {
        if (actionType === "full") {
          if (payload.rack_id) {
            await axios.put(
              `${url.backendURL}order/${id}/item/${effectiveOrderItemId}/field`,
              { rack_id: payload.rack_id },
              { headers: { Authorization: `${token}` } },
            );
          }
          await axios.put(
            `${url.backendURL}order/${id}/item/${effectiveOrderItemId}`,
            { serialNumbers: serials[String(effectiveOrderItemId)] || [] },
            { headers: { Authorization: `${token}` } },
          );
        } else {
          payload.receivedQuantity = intValue;
          await axios.put(
            `${url.backendURL}order/${id}/item/${effectiveOrderItemId}/field`,
            payload,
            { headers: { Authorization: `${token}` } },
          );
        }

        setAlert({
          message: "Product received successfully",
          type: "success",
          show: true,
          alertFor: "order-add",
        });
        setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);

        await getOrder();
        await getOrderProducts(orderPagination.pageIndex, orderPagination.pageSize, orderGlobalFilter);
      } catch (err) {
        handleError(err, "order-add");
      }
    }
    setPendingSerialUpdate(null);
  };

  const handleSerialCancel = () => {
    setShowSerialModal(false);
    setActivePanel("none");
    if (pendingSerialUpdate?.resetInput) pendingSerialUpdate.resetInput();
    else if (pendingSerialUpdate?.uniqueId)
      setActiveRows((prev) => prev.filter((i) => i !== pendingSerialUpdate.uniqueId));
    setPendingSerialUpdate(null);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const allItems = [...newlyImportedProducts, ...backendOrderProducts].map((item) => ({
        productId: Number(item.product_id),
        quantity: Number(item.quantity),
        orderItemId: item.order_item_id ? Number(item.order_item_id) : null,
        rate: item.rate,
        receivedQuantity: item.received_quantity,
        oldQuantity: item.old_quantity,
        newQuantity: item.new_quantity,
        jobId: item.job_id ? Number(item.job_id) : null,
        productRequestId: item.product_request_id || null,
        systemId: item.system_id ? Number(item.system_id) : null,
        phaseId: item.phase_id ? Number(item.phase_id) : null,
        description: item.description || "",
        // rack_id: item.rack_id || null,
      }));
      await validationSchemaItem().validate({ items: allItems }, { abortEarly: false });
      setValidationErrors();
      const newItemsOnly = allItems.filter((item) => !item.orderItemId);
      if (newItemsOnly.length === 0) return;
      const sanitizedItems = newItemsOnly.map(({ oldQuantity, orderItemId, ...rest }) => rest);
      const response = await axios.put(
        `${url.backendURL}order/${id}`,
        { items: sanitizedItems },
        { headers: { Authorization: `${token}` } },
      );
      setActivePanel("none");
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setValidationErrors();
      const allProductsFullyReceived = [...newlyImportedProducts, ...backendOrderProducts].every(
        (product) => (product.received_quantity || 0) + (product.new_quantity || 0) >= product.quantity,
      );
      let successMessage = response.data.message;
      if (allProductsFullyReceived) successMessage = "Order status updated to Received successfully";
      else if (hasAnyProductMarkedReceived()) successMessage = "Order status set to Partially Received successfully";
      if (showPartialWarning) setShowPartialWarning(false);
      setAlert({ message: successMessage, type: "success", show: true, alertFor: "order-add" });
      setNewlyImportedProducts([]);
      setSelectedProductKeys(new Set());
      setSelectedProductsData(new Map());
      await getOrderProducts();
      setHasUnsavedChanges(false);
      await getOrder(true);
      setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 2000);
    } catch (err) {
      if (err.name === "ValidationError") {
        const errorsObj = {};
        const isEmptyItemsError = err.errors.includes("Items are required");
        if (isEmptyItemsError) {
          setValidationErrors("At least one item is required");
        } else {
          let fallbackMessage = "";
          const originalItems = [...newlyImportedProducts, ...backendOrderProducts];
          err.inner.forEach((validationError) => {
            const { path, message } = validationError;
            const match = path && path.match(/^items\[(\d+)\]\.(.+)$/);
            if (match) {
              const idx = Number(match[1]);
              const field = match[2];
              const item = originalItems[idx];
              if (item) {
                const key = createProductKey(item);
                if (!errorsObj[key]) errorsObj[key] = {};
                errorsObj[key][field] = message;
              } else {
                fallbackMessage = fallbackMessage || message;
              }
            } else {
              fallbackMessage = fallbackMessage || message;
            }
          });
          if (Object.keys(errorsObj).length > 0) {
            setValidationErrors(errorsObj);
            setAlert({ message: "Rate must be greater than 0", type: "danger", show: true, alertFor: "order-add" });
             setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);
          } else if (fallbackMessage) setValidationErrors(fallbackMessage);
          else setValidationErrors("Please fill all required fields correctly");
          if (alertRef?.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } else {
        if (alertRef?.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        handleError(err, "order-add");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const [fieldSubmit, setFieldSubmit] = useState();
  const [successOrderDetailSubmit, setSuccessOrderDetailSubmit] = useState();
  const [failOrderDetailSubmit, setFailOrderDetailSubmit] = useState();

  const handleSubmitOrderDetail = async (field, value, additionalFields = {}) => {
    setFailOrderDetailSubmit(null);
    setSuccessOrderDetailSubmit(null);
    setFieldSubmit(field);
    try {
      const response = await axios.put(
        `${url.backendURL}order/${id}/detail`,
        { [field]: value, ...additionalFields },
        { headers: { Authorization: `${token}` } },
      );
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setAlert({ message: response.data.message, type: "success", show: true, alertFor: "order-add" });
      setSuccessOrderDetailSubmit(field);
      setSelectedData({ ...selectedData, [field]: value, ...additionalFields });
      setInitialFormValues({ ...initialFormValues, [field]: value, ...additionalFields });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
        setSuccessOrderDetailSubmit(null);
      }, 3000);
    } catch (err) {
      setSuccessOrderDetailSubmit(null);
      setFailOrderDetailSubmit(field);
      if (alertRef?.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "order-add");
      setTimeout(() => setFailOrderDetailSubmit(null), 2000);
    } finally {
      setFieldSubmit(null);
    }
  };

  const fetchJobSystemsPhases = async (jobId) => {
    if (!jobId) return null;
    if (jobSystemsPhasesMap[jobId]) return jobSystemsPhasesMap[jobId];
    try {
      const response = await axios.get(
        `${url.backendURL}product-request/${jobId}/job/systems-with-phases`,
        { headers: { Authorization: `${token}` } },
      );
      const data = response.data.response.data;
      setJobSystemsPhasesMap((prev) => ({ ...prev, [jobId]: data }));
      return data;
    } catch (err) {
      return null;
    }
  };

  const fetchProductSuggestions = async (inputValue, selectedProductIds = [], keyCol, directionCol, limit, offset) => {
    try {
      const response = await axios.get(`${url.backendURL}job/products`, {
        headers: { Authorization: `${token}` },
        params: {
          product: inputValue, searchKey: keyCol, searchDirection: directionCol,
          limit, offset,
          vendorId: vendorId !== "all" ? vendorId : undefined,
          excludeProducts: selectedProductIds.length > 0 ? JSON.stringify(selectedProductIds) : undefined,
        },
      });
      const products = response.data.response.data;
      const pagination = response.data.response.pagination;
      return {
        products: products.map((product) => ({
          productId: product.product_id,
          productName: product.product_name,
          rate: product.product_cost,
          quantity: 1,
          amount: product.product_cost,
          model: product.product_model,
          manufacturerId: product.manufacturer_id,
          manufacturerName: product.manufacturer_name,
          sku: product.sku,
          inventoryType: product.inventory_type,
          description: product.product_description,
          phases: product.phases,
          phaseNames: product.phase_names,
          searchable_text: product.searchable_text,
          systemId: null,
          phaseId: null,
        })),
        total: pagination.total,
        offset: pagination.offset,
        nextOffset: pagination.nextOffset,
      };
    } catch (error) {
      if (error.response?.data?.error === "jwt expired" || error.response?.data?.error === "Unauthorized. User not found") {
        localStorage.removeItem("coyote-token");
        navigate(
          `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
          { state: { status: "expired" } },
        );
      }
      return { products: [], total: -1, offset: 0, nextOffset: null };
    }
  };

  const gpCreateKey = (productId, systemId, phaseId) =>
    `${productId}-${systemId || "null"}-${phaseId || "null"}`;

  const gpIsInSelection = (productId, systemId, phaseId) => {
    const k = gpCreateKey(productId, systemId, phaseId);
    return gpSelectedProducts.some((p) => gpCreateKey(p.productId, p.systemId, p.phaseId) === k);
  };

  const gpLoadInitial = async (search = "", sortKey = "productName", sortDir = "asc", forcedExcludedList = null) => {
    setGpLoadingInitial(true);
    gpRequestIdRef.current += 1;
    const rid = gpRequestIdRef.current;
    try {
      const excludedToUse = forcedExcludedList
        ? forcedExcludedList.filter((p) => !p.product_request_id).map((p) => p.product_id)
        : [...newlyImportedProducts, ...backendOrderProducts].filter((p) => !p.product_request_id).map((p) => p.product_id);
      const data = await fetchProductSuggestions(search, excludedToUse, sortKey, sortDir, GP_LIMIT, 0);
      if (gpRequestIdRef.current !== rid) return;
      const prods = (data?.products || []).map((p) => ({
        ...p,
        jobId: gpSelectedJobId, systemId: gpSelectedSystemId, phaseId: gpSelectedPhaseId,
        quantity: p.quantity || 1, rate: p.rate || 0,
        amount: (p.rate || 0) * (p.quantity || 1), phaseNames: p.phaseNames,
      }));
      setGpProducts(prods);
      setGpTotal(data?.total || 0);
      setGpNextOffset(data?.nextOffset || null);
      setGpOffset(0);
    } catch (err) {
      console.error("GP load error:", err);
    } finally {
      if (gpRequestIdRef.current === rid) setGpLoadingInitial(false);
    }
  };

  const gpLoadMore = async () => {
    if (!gpNextOffset) return;
    setGpLoadingMore(true);
    try {
      const excludedToUse = [...newlyImportedProducts, ...backendOrderProducts]
        .filter((p) => !p.product_request_id).map((p) => p.product_id);
      const data = await fetchProductSuggestions(gpSearchText, excludedToUse, gpSortConfig.key, gpSortConfig.direction, GP_LIMIT, gpNextOffset);
      if (data?.products?.length > 0) {
        const prods = data.products.map((p) => ({
          ...p,
          jobId: gpSelectedJobId, systemId: gpSelectedSystemId, phaseId: gpSelectedPhaseId,
          quantity: p.quantity || 1, rate: p.rate || 0,
          amount: (p.rate || 0) * (p.quantity || 1), phaseNames: p.phaseNames,
        }));
        setGpProducts((prev) => [...prev, ...prods]);
        setGpTotal(data.total || gpTotal);
        setGpNextOffset(data.nextOffset || null);
        setGpOffset(data.offset || gpOffset);
      }
    } catch (err) {
      console.error("GP load more error:", err);
    } finally {
      setGpLoadingMore(false);
    }
  };

  const gpSelectRow = (product, onlySelect = false) => {
    setGpSelectedProducts((prev) => {
      const k = gpCreateKey(product.productId, product.systemId, product.phaseId);
      const isSel = prev.some((p) => gpCreateKey(p.productId, p.systemId, p.phaseId) === k);
      if (isSel) {
        if (onlySelect) return prev;
        return prev.filter((p) => gpCreateKey(p.productId, p.systemId, p.phaseId) !== k);
      }
      return [
        ...prev,
        { ...product, quantity: product.quantity || 1, rate: product.rate || 0, amount: (product.rate || 0) * (product.quantity || 1) },
      ];
    });
  };

  const gpUpdateField = (productId, systemId, phaseId, key, value) => {
    const update = (item) => {
      if (item.productId !== productId || item.systemId !== systemId || item.phaseId !== phaseId) return item;
      return {
        ...item,
        [key]: value,
        amount:
          key === "rate"
            ? (parseFloat(value) || 0) * (parseFloat(item.quantity) || 1)
            : key === "quantity"
              ? (parseFloat(item.rate) || 0) * (parseFloat(value) || 0)
              : item.amount,
      };
    };
    setGpSelectedProducts((prev) => prev.map(update));
    setGpProducts((prev) => prev.map(update));
  };

  const gpValidate = () => {
    const errs = {};
    let hasErrors = false;
    gpSelectedProducts.forEach((item) => {
      const k = gpCreateKey(item.productId, item.systemId, item.phaseId);
      errs[k] = {};
      if (!item.quantity || item.quantity <= 0) { errs[k].quantity = "Quantity is required"; hasErrors = true; }
      if (item.rate === "" || item.rate === null || item.rate === undefined) { errs[k].rate = "Rate is required"; hasErrors = true; }
      const hasAnyJSP = item.jobId || item.systemId || item.phaseId;
      const allJSP = item.jobId && item.systemId && item.phaseId;
      if (hasAnyJSP && !allJSP) {
        if (!item.jobId) errs[k].jobId = "Job is required";
        if (!item.systemId) errs[k].systemId = "System is required";
        if (!item.phaseId) errs[k].phaseId = "Phase is required";
        hasErrors = true;
      }
    });
    setGpValidationErrors(errs);
    return !hasErrors;
  };

  const gpHandleAdd = () => {
    if (!gpValidate() || gpSelectedProducts.length === 0) return;
    handleAddGeneralProductsToOrder(gpSelectedProducts);
    setGpSelectedProducts([]);
    setGpValidationErrors({});
  };

  useEffect(() => {
    if (gpOptionsJob.length === 0 && token) {
      (async () => {
        try {
          const res = await axios.get(`${url.backendURL}job/all`, { headers: { Authorization: token } });
          const jobs = res.data.response.data || [];
          setGpOptionsJob(
            jobs.map((j) => ({
              value: j.id, label: j.name,
              phaseName: j.phaseName || j.phase_name,
              systemName: j.systemName || j.system_name,
              siteName: j.siteName || j.site_name || "",
              status: j.status,
            })),
          );
        } catch (e) {
          console.error("GP fetch jobs error:", e);
        }
      })();
    }
  }, [token, gpOptionsJob.length]);

  useEffect(() => {
    if (showGeneralProductsPanel) {
      gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction);
    } else {
      setGpProducts([]);
      setGpSearchText("");
      setGpSelectedProducts([]);
      setGpValidationErrors({});
      setGpSelectedJobId(null);
      setGpSelectedSystemId(null);
      setGpSelectedPhaseId(null);
      setGpSystemOptions([]);
      setGpPhaseOptions([]);
      setGpSortConfig({ key: "productName", direction: "asc" });
      setGpNextOffset(null);
      setGpOffset(0);
      setGpTotal(0);
    }
  }, [showGeneralProductsPanel, gpSearchText, gpSortConfig.key, gpSortConfig.direction, vendorId]);

  useEffect(() => {
    if (bulkJobId) {
      (async () => {
        const data = await fetchJobSystemsPhases(bulkJobId);
        if (data && data.systems) {
          setBulkSystemOptions(data.systems.map((s) => ({ value: s.system_id, label: s.system_name })));
        } else {
          setBulkSystemOptions([]);
        }
      })();
    } else {
      setBulkSystemOptions([]);
      setBulkPhaseOptions([]);
    }
  }, [bulkJobId]);

  useEffect(() => {
    if (bulkJobId && bulkSystemId && jobSystemsPhasesMap[bulkJobId]) {
      const sys = jobSystemsPhasesMap[bulkJobId].systems.find((s) => s.system_id === bulkSystemId);
      if (sys && sys.phases) {
        setBulkPhaseOptions(sys.phases.map((p) => ({ value: p.phase_id, label: p.phase_name })));
      } else {
        setBulkPhaseOptions([]);
      }
    } else {
      setBulkPhaseOptions([]);
    }
  }, [bulkJobId, bulkSystemId, jobSystemsPhasesMap]);

  useEffect(() => {
    if (bulkJobId || bulkSystemId || bulkPhaseId) {
      setNewlyImportedProducts((prev) => {
        let changedSomewhere = false;
        const next = prev.map((p) => {
          if (p.product_request_id || !p.isNewlyImported) return p;
          const update = { ...p };
          let changed = false;
          if (bulkJobId && !p.job_id) {
            const jobOpt = gpOptionsJob.find((o) => o.value === bulkJobId);
            update.job_id = bulkJobId;
            update.job_name = jobOpt?.label || "";
            update.site_name = jobOpt?.siteName || "";
            changed = true;
          }
          if (bulkSystemId && !p.system_id && update.job_id === bulkJobId) {
            const sysOpt = bulkSystemOptions.find((o) => o.value === bulkSystemId);
            update.system_id = bulkSystemId;
            update.system_name = sysOpt?.label || "";
            changed = true;
          }
          if (bulkPhaseId && !p.phase_id && update.system_id === bulkSystemId) {
            const phOpt = bulkPhaseOptions.find((o) => o.value === bulkPhaseId);
            update.phase_id = bulkPhaseId;
            update.phase_name = phOpt?.label || "";
            changed = true;
          }
          if (changed) {
            update.searchable_text = generateSearchableText(update);
            changedSomewhere = true;
          }
          return changed ? update : p;
        });
        return changedSomewhere ? next : prev;
      });
    }
  }, [bulkJobId, bulkSystemId, bulkPhaseId, gpOptionsJob, bulkSystemOptions, bulkPhaseOptions, newlyImportedProducts.length]);

  const handleAddGeneralProductsToOrder = (addedProducts) => {
    const normalizeId = (id) => {
      if (id === null || id === undefined || id === "") return null;
      const num = Number(id);
      return isNaN(num) ? null : num;
    };

    addedProducts.forEach((product) => {
      const jobOption = gpOptionsJob.find((j) => Number(j.value) === Number(product.jobId));
      const jobName = jobOption?.label || "";
      const siteName = jobOption?.siteName || "";
      let systemName = "", phaseName = "";
      if (product.jobId && jobSystemsPhasesMap[product.jobId]) {
        const jd = jobSystemsPhasesMap[product.jobId];
        if (jd.systems && product.systemId) {
          const sys = jd.systems.find((s) => s.system_id === product.systemId);
          if (sys) {
            systemName = sys.system_name || "";
            if (sys.phases && product.phaseId) {
              const ph = sys.phases.find((p) => p.phase_id === product.phaseId);
              if (ph) phaseName = ph.phase_name || "";
            }
          }
        }
      }
      const qty = Number(product.quantity) || 1;
      const rate = Number(product.rate) || 0;
      const newProduct = {
        product_id: product.productId,
        product_request_id: null,
        system_id: product.systemId || null,
        phase_id: product.phaseId || null,
        job_id: product.jobId || null,
        quantity: qty,
        rate,
        amount: rate * qty,
        description: product.description || "",
        name: product.productName,
        manufacturer_name: product.manufacturerName,
        model: product.model,
        sku: product.sku,
        inventory_type: product.inventoryType,
        warehouse_name: warehouseOptions.find((w) => w.value === selectedData?.warehouseId)?.label || "",
        job_name: jobName,
        system_name: systemName,
        phase_name: phaseName || product.phaseNames || "",
        site_name: siteName,
        isFromBackend: false,
        new_quantity: 0,
        old_quantity: 0,
        received_quantity: 0,
        isNewlyImported: true,
      };
      newProduct.searchable_text = [generateSearchableText(newProduct), product.searchable_text].filter(Boolean).join(" ");
      setOrderPagination((prev) => ({ ...prev, pageIndex: 0 }));
      setNewlyImportedProducts((prev) => {
        const existing = prev.findIndex(
          (p) =>
            normalizeId(p.product_id) === normalizeId(newProduct.product_id) &&
            normalizeId(p.job_id) === normalizeId(newProduct.job_id) &&
            normalizeId(p.system_id) === normalizeId(newProduct.system_id) &&
            normalizeId(p.phase_id) === normalizeId(newProduct.phase_id) &&
            !p.product_request_id,
        );
        if (existing !== -1) {
          const updated = [...prev];
          const mergedQty = Number(updated[existing].quantity) + qty;
          const existingRate = Number(updated[existing].rate) || 0;
          updated[existing] = { ...updated[existing], quantity: mergedQty, amount: existingRate * mergedQty };
          return updated;
        }
        return [newProduct, ...prev];
      });
    });
    setHasUnsavedChanges(true);
    if (showGeneralProductsPanel) {
      const allNew = [...newlyImportedProducts];
      addedProducts.forEach((prod) => {
        const item = { product_id: prod.productId, product_request_id: null, job_id: prod.jobId, system_id: prod.systemId, phase_id: prod.phaseId };
        allNew.push(item);
      });
      gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction, [...allNew, ...backendOrderProducts]);
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    if (response?.data?.error === "jwt expired" || response?.data?.error === "Unauthorized. User not found") {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "expired" } },
      );
    } else {
      setErrors(response?.data?.error || {});
      setAlert({ message: response ? response.data.message : "An error occurred", type: "danger", show: true, alertFor });
      setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);
    }
  };

  const validationSchema = () =>
    Yup.object().shape({
      date: Yup.string().required("Date is required"),
      poNumber: Yup.string()
        .matches(/^[A-Za-z0-9-]+$/, "PO # can only contain alphanumeric characters and hyphens")
        .required("PO # is required").trim(),
      vendorId: Yup.number().integer().positive().typeError("Vendor is invalid").required("Vendor is required"),
      warehouseId: Yup.number().integer().positive().typeError("Warehouse is invalid").required("Warehouse is required"),
      shipTo: Yup.string()
        .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/, "Ship To address must contain at least 2 character long")
        .min(2).max(255).trim().required("Ship To address is required"),
    });

  const [optionsVendor, setOptionsVendor] = useState([]);
  const [optionsVendorForPO, setOptionsVendorForPO] = useState([]);

  useEffect(() => {
    setOptionsVendor([
      { value: "all", label: "Select Vendor" },
      ...allVendors.map((vendor) => ({
        value: vendor.id,
        label: vendor.name === "N/A" || !vendor.name ? "No vendor" : vendor.name,
      })),
    ]);
  }, [allVendors]);

  useEffect(() => {
    setOptionsVendorForPO(
      allVendors.map((vendor) => ({
        value: vendor.id,
        label: vendor.name === "N/A" || !vendor.name ? "No vendor" : vendor.name,
      })),
    );
  }, [allVendors]);

  const validationSchemaItem = () =>
    Yup.object().shape({
      items: Yup.array()
        .of(
          Yup.object()
            .shape({
              productRequestId: Yup.number().integer().nullable().optional().typeError("Product request must be a valid"),
              productId: Yup.number().integer().required("Product is required").typeError("Product must be a valid"),
              jobId: Yup.number().integer().nullable().optional().typeError("Job must be a valid"),
              systemId: Yup.number().integer().nullable().optional().typeError("System must be a valid"),
              phaseId: Yup.number().integer().nullable().optional().typeError("Phase must be a valid"),
              quantity: Yup.number().required("Quantity is required").integer("Quantity must be an integer").typeError("Quantity must be a number").positive("Quantity must be greater than 0"),
              receivedQuantity: Yup.number().required("Received quantity is required").integer().typeError("Received quantity must be a number"),
              oldQuantity: Yup.number().required("Old quantity is required").integer().typeError("Old quantity must be a number"),
              newQuantity: Yup.number().required("New quantity is required").integer().typeError("New quantity must be a number"),
              description: Yup.string().max(5000, "Description must not exceed 5000 characters"),
              rate: Yup.number()
                .required("Rate is required").typeError("Rate must be a number")
                .transform((value) => (value === "" ? null : value))
                .moreThan(0, "Rate must be greater than 0")
                .test("is-decimal", "Rate must have a maximum of 2 decimal places", (value) => value === null || /^[+-]?\d+(\.\d{1,2})?$/.test(value)),
            })
            .test("quantity-check", "Invalid quantity values", function (item) {
              const { quantity, receivedQuantity, oldQuantity, newQuantity } = item;
              if (typeof quantity !== "number" || typeof receivedQuantity !== "number" || typeof oldQuantity !== "number" || typeof newQuantity !== "number") return true;
              if (newQuantity > quantity) return this.createError({ path: "newQuantity", message: "New quantity must not exceed total quantity" });
              if (oldQuantity > quantity) return this.createError({ path: "oldQuantity", message: "Old quantity must not exceed total quantity" });
              if (receivedQuantity > quantity) return this.createError({ path: "receivedQuantity", message: "Received quantity must not exceed total quantity" });
              if (receivedQuantity !== oldQuantity) return this.createError({ path: "receivedQuantity", message: "Received quantity must be equal to old quantity" });
              if (newQuantity + oldQuantity > quantity) return this.createError({ path: "newQuantity", message: "New + Old quantity must not exceed total quantity" });
              return true;
            }),
        )
        .min(1, "At least one item is required")
        .required("Items are required"),
    });

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    setWarehouseOptions(
      warehouses.length > 0
        ? warehouses.map((warehouse) => ({ value: warehouse.id, label: warehouse.name, address: warehouse.address }))
        : [],
    );
  }, [warehouses]);

  const handleSelectRowProduct = (row) => {
    const productKey = createProductKey(row.original);
    const isCurrentlySelected = row.original.isSelected;
    setProducts((prevProducts) =>
      prevProducts.map((product) => {
        const key = createProductKey(product);
        if (key === productKey && product.status !== "in-active" && !product.moved) {
          return { ...product, isSelected: !isCurrentlySelected };
        }
        return product;
      }),
    );
    setSelectedProductKeys((prevSelected) => {
      const newSelected = new Set(prevSelected);
      isCurrentlySelected ? newSelected.delete(productKey) : newSelected.add(productKey);
      return newSelected;
    });
    setSelectedProductsData((prevData) => {
      const newData = new Map(prevData);
      isCurrentlySelected ? newData.delete(productKey) : newData.set(productKey, row.original);
      return newData;
    });
  };

  const productColumns = useMemo(
    () => [
      {
        id: "select", header: "", size: 40,
        Cell: ({ row }) => (
          <Checkbox
            checked={row.original.isSelected || false}
            disabled={row.original.status === "in-active" || row.original.moved}
            onChange={() => handleSelectRowProduct(row)}
          />
        ),
      },
      { accessorKey: "quantity", header: "Quantity", size: 150 },
      { accessorKey: "manufacturer_name", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorFn: (row) => row.description || "", id: "description", header: "Description", size: 150 },
      { accessorKey: "sku", header: "SKU", size: 150 },
      { accessorKey: "rate", header: "Rate", size: 150 },
      { accessorKey: "amount", header: "Amount", size: 150 },
      { accessorKey: "job_name", header: "Job", size: 150 },
      { accessorKey: "system_name", header: "System", size: 150 },
      { accessorKey: "phase_name", header: "Phase", size: 150 },
      { accessorKey: "warehouse_name", header: "Warehouse", size: 150 },
      { accessorKey: "site_name", header: "Site Name", size: 150 },
    ],
    [],
  );

  const updateProductInOrder = (productId, value, key, product, productRequestId, systemId, phaseId) => {
    const updater = (prevProducts) =>
      prevProducts.map((item) => {
        const itemKey = createProductKey(item);
        const targetKey = createProductKey({ product_id: productId, product_request_id: productRequestId, job_id: product.job_id, system_id: systemId, phase_id: phaseId });
        return itemKey === targetKey ? { ...item, [key]: value } : item;
      });
    setNewlyImportedProducts(updater);
    setBackendOrderProducts(updater);
  };

  const [activeRows, setActiveRows] = useState([]);

  const submitReceivedQuantity = async (newReceivedQuantity, orderItemId, setIsSubmittingReceivedQuantity, setSuccessReceivedQuantityLoader, setReceivedQuantityValue, setErrorReceivedQuantityLoader, isSubmittingReceivedQuantity, cell, itemSerials = {}) => {
    if (isSubmittingReceivedQuantity) return;
    if (orderItemId) {
      try {
        setIsSubmittingReceivedQuantity(true);
        const response = await axios.put(
          `${url.backendURL}order/${id}/item/${orderItemId}/field`,
          { receivedQuantity: newReceivedQuantity, serialNumbers: itemSerials },
          { headers: { Authorization: `${token}` } },
        );
        setIsSubmittingReceivedQuantity(false);
        setSuccessReceivedQuantityLoader(true);
        const updatedBackendOrderProducts = backendOrderProducts.map((item) =>
          item.order_item_id === orderItemId
            ? { ...item, new_quantity: 0, received_quantity: (item.received_quantity || 0) + newReceivedQuantity, old_quantity: (item.received_quantity || 0) + newReceivedQuantity, isFromBackend: true }
            : item,
        );
        setOldOrderProducts(
          oldOrderProducts.map((data) =>
            orderItemId === data.order_item_id
              ? { ...data, received_quantity: (data.received_quantity || 0) + newReceivedQuantity, old_quantity: (data.received_quantity || 0) + newReceivedQuantity, new_quantity: 0 }
              : data,
          ),
        );
        setBackendOrderProducts(updatedBackendOrderProducts);
        const mergedProducts = [...newlyImportedProducts, ...updatedBackendOrderProducts];
        const allProductsFullyReceived = mergedProducts.every((product) => (product.received_quantity || 0) >= product.quantity);
        let successMessage = "";
        if (allProductsFullyReceived) successMessage = "Order status updated to Received successfully";
        else if (hasAnyProductMarkedReceived()) successMessage = "Order status set to Partially Received successfully";
        if (showPartialWarning) setShowPartialWarning(false);
        if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        setAlert({ message: successMessage, type: "success", show: true, alertFor: "order-add" });
        setActiveRowInput(false);
        setTimeout(() => { setAlert({ show: false, alertFor: "", message: "", type: "" }); setSuccessReceivedQuantityLoader(false); }, 3000);
      } catch (err) {
        if (alertRefProduct.current) alertRefProduct.current.scrollIntoView({ behavior: "smooth", block: "start" });
        handleError(err, "order-add");
        setReceivedQuantityValue(cell.getValue() || "");
        setErrorReceivedQuantityLoader(true);
        setIsSubmittingReceivedQuantity(false);
        setTimeout(() => setErrorReceivedQuantityLoader(false), 5000);
      }
    }
  };

  const checkReceivedQuantity = () => {
    const mergedProducts = [...newlyImportedProducts, ...backendOrderProducts];
    return mergedProducts.every((product) => product.received_quantity >= product.quantity);
  };

  const ReceivedQuantityCell = ({ cell }) => {
    const row = cell.row.original;
    const productId = row.product_id;
    const productRequestId = row.product_request_id;
    const systemId = row.system_id;
    const phaseId = row.phase_id;
    const orderItemId = row.order_item_id;
    const quantity = row.quantity;
    const receivedQuantity = cell.getValue() || 0;
    const newQuantity = row.new_quantity || 0;
    const uniqueId = `edit-${productRequestId}-${productId}-${systemId}-${phaseId}`;
    const isActive = activeRows.includes(uniqueId);
    const [receivedQuantityValue, setReceivedQuantityValue] = useState(receivedQuantity?.toString() || "");
    const [inputValue, setInputValue] = useState("");
    const [focused, setFocused] = useState(false);
    const [isSubmittingReceivedQuantity, setIsSubmittingReceivedQuantity] = useState(false);
    const [successReceivedQuantityLoader, setSuccessReceivedQuantityLoader] = useState(false);
    const [errorReceivedQuantityLoader, setErrorReceivedQuantityLoader] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const inputRef = useRef(null);
    const { old_quantity } = cell.row.original;
    const totalReceived = receivedQuantity + newQuantity;
    const isDisabled = receivedQuantity >= quantity;

    const handleChange = (e) => {
      const value = e.target.value;
      if (/^\d*$/.test(value) || value === "") setInputValue(value);
    };

    const handleBlur = async () => {
      const intValue = parseInt(inputValue || "0", 10);
      if (isNaN(intValue) || intValue === 0) {
        setInputValue(""); setFocused(false); setActiveRowInput(false);
        setActiveRows((prev) => prev.filter((id) => id !== uniqueId));
        return;
      }
      if (intValue > 0 && intValue <= quantity - receivedQuantity) {
        const needsSerial =
          row.inventory_type?.toLowerCase() === "serial" ||
          row.inventory_type === "Serial Number";
        const needsRack = rackOptions.length > 0 && !row.rack_id && !row.default_bin_id;

        if (needsSerial || needsRack) {
          setSerialItems([
            {
              orderItemId: orderItemId || null,
              productId,
              productName: row.name,
              quantity,
              newQuantity: intValue,
              job_name: row.job_name,
              system_name: row.system_name,
              phase_name: row.phase_name,
              warehouse_name: row.warehouse_name,
              warehouse_id: row.warehouse_id,
              rack_id: row.rack_id || row.default_bin_id || null,
              rack_name: row.rack_name || "",
              rack_number: row.rack_number || "",
              row_number: row.row_number || "",
              column_number: row.column_number || "",
              inventory_type: row.inventory_type,
            },
          ]);
          setPendingSerialUpdate({
            type: "partial",
            intValue,
            orderItemId,
            setIsSubmittingReceivedQuantity,
            setSuccessReceivedQuantityLoader,
            setReceivedQuantityValue,
            setErrorReceivedQuantityLoader,
            isSubmittingReceivedQuantity,
            cell,
            row,
            uniqueId,
            resetInput: () => {
              setInputValue("");
              setFocused(false);
              setActiveRowInput(false);
              setActiveRows((prev) => prev.filter((id) => id !== uniqueId));
            },
          });
          setActivePanel("serial");
          return;
        }
        row.new_quantity = intValue;
        await submitReceivedQuantity(intValue, orderItemId, setIsSubmittingReceivedQuantity, setSuccessReceivedQuantityLoader, setReceivedQuantityValue, setErrorReceivedQuantityLoader, isSubmittingReceivedQuantity, cell);
        setShowSuccessMessage(true);
        setTimeout(() => { setSuccessReceivedQuantityLoader(false); setErrorReceivedQuantityLoader(false); setShowSuccessMessage(false); }, 3000);
      }
      setInputValue(""); setFocused(false); setActiveRowInput(false);
      setActiveRows((prev) => prev.filter((id) => id !== uniqueId));
    };

    const handleFocus = () => {
      if (!isDisabled) { setFocused(true); setInputValue(newQuantity > 0 ? newQuantity.toString() : ""); setShowSuccessMessage(false); }
    };

    const inputNewValue = parseInt(inputValue || "0", 10);
    const totalAfterInput = receivedQuantity + inputNewValue;
    const showComparison = focused && inputValue !== "";
    const displayValue = focused ? inputValue : totalReceived;

    return (
      <Box sx={{ width: "100%" }}>
        <TextField
          type="text" inputRef={inputRef} id={`quantity-input-${uniqueId}`} inputMode="numeric"
          value={displayValue} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur}
          variant="outlined" size="small" fullWidth
          disabled={(!hasImportUpdatePermission && decodedToken?.roles?.some((role) => role.role_type !== roleTypes.SUPER_ADMIN)) || !isActive || isDisabled || !orderItemId || isSubmittingReceivedQuantity || orderStatusCancelled || orderStatusReceived}
          sx={{
            "& .MuiInputBase-input": { cursor: quantity === old_quantity ? "not-allowed !important" : isSubmittingReceivedQuantity ? "wait" : "text" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: successReceivedQuantityLoader ? "2px solid #198754 !important" : errorReceivedQuantityLoader ? "2px solid #d91111ff !important" : isActive && focused ? "2px solid #3b82f6" : "1px solid rgba(0, 0, 0, 0.23)" },
              "&:hover fieldset": { border: successReceivedQuantityLoader ? "2px solid #198754 !important" : errorReceivedQuantityLoader ? "2px solid #d91111ff !important" : isActive ? "2px solid #3b82f6" : "1px solid rgba(0, 0, 0, 0.87)" },
              "&.Mui-focused fieldset": { border: successReceivedQuantityLoader ? "2px solid #198754 !important" : errorReceivedQuantityLoader ? "2px solid #d91111ff !important" : "2px solid #3b82f6 !important" },
            },
          }}
          InputProps={{
            startAdornment: showComparison && (
              <InputAdornment position="start">
                <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.75rem", fontWeight: 100 }}>{receivedQuantity} +</Typography>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {isSubmittingReceivedQuantity ? (
                  <RotatingLines strokeWidth="5" animationDuration="0.75" width="15" strokeColor="#b2b4b9" visible={true} />
                ) : successReceivedQuantityLoader ? (
                  <Check style={{ color: "#198754", width: "20px", height: "20px" }} />
                ) : errorReceivedQuantityLoader ? (
                  <X style={{ color: "#d91111ff", width: "20px", height: "20px" }} />
                ) : (
                  <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.75rem" }}>
                    = {showComparison ? totalAfterInput : totalReceived} / {quantity}
                  </Typography>
                )}
              </InputAdornment>
            ),
          }}
        />
        {(quantity < totalAfterInput || displayValue > quantity) && focused && (
          <Box sx={{ mt: 0.5, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography variant="caption" sx={{ color: "error.main", fontSize: "0.7rem" }}>
              {`Can't receive quantity more than ${quantity - receivedQuantity} remaining quantity`}
            </Typography>
          </Box>
        )}
        {!focused && receivedQuantity >= quantity && !showSuccessMessage && (
          <Box sx={{ mt: 0.5, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography variant="caption" sx={{ color: "success.main", fontSize: "0.7rem", fontWeight: 600 }}>✓ Fully Received</Typography>
          </Box>
        )}
        {showSuccessMessage && !focused && (
          <Box sx={{ mt: 0.5, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography variant="caption" sx={{ color: "success.main", fontSize: "0.7rem", fontWeight: 500 }}>Received quantity updated successfully</Typography>
          </Box>
        )}
      </Box>
    );
  };

  const [itemView, setItemView] = useState();
  const [itemViewModel, setItemViewModel] = useState(false);
  const handleProductView = async (e, item) => { e.preventDefault(); setItemView(item); setItemViewModel(true); };
  const [showReceivePopover, setShowReceivePopover] = useState(null);
  const [isConfirmingReceive, setIsConfirmingReceive] = useState(false);

  const handleFullReceived = async (e, productData, capturedSerials = null) => {
    if (e) e.preventDefault();
    const needsSerial = productData.inventory_type?.toLowerCase() === "serial" || productData.inventory_type === "Serial Number";
    const needsRack = rackOptions.length > 0 && !productData.rack_id && !productData.default_bin_id;

    if ((needsSerial || needsRack) && !capturedSerials) {
      setShowFullReceivedModal(false);
      const remainingToReceive = productData.quantity - (productData.received_quantity || 0);
      setSerialItems([
        {
          orderItemId: productData.order_item_id,
          productId: productData.product_id,
          productName: productData.name,
          quantity: productData.quantity,
          newQuantity: remainingToReceive,
          job_name: productData.job_name,
          system_name: productData.system_name,
          phase_name: productData.phase_name,
          warehouse_name: productData.warehouse_name,
          warehouse_id: productData.warehouse_id,
          rack_id: productData.rack_id || productData.default_bin_id || null,
          rack_name: productData.rack_name || "",
          rack_number: productData.rack_number || "",
          row_number: productData.row_number || "",
          column_number: productData.column_number || "",
          inventory_type: productData.inventory_type,
        },
      ]);
      setPendingSerialUpdate({ type: "full", productData });
      setActivePanel("serial");
      return;
    }
    if (isConfirmingReceive) return;
    setIsConfirmingReceive(true);
    try {
      const response = await axios.put(
        `${url.backendURL}order/${id}/item/${productData.order_item_id}`,
        { serialNumbers: capturedSerials },
        { headers: { Authorization: `${token}` } },
      );
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      const mergedProducts = [...newlyImportedProducts, ...backendOrderProducts];
      const updatedMergedProducts = mergedProducts.map((product) =>
        product.order_item_id === productData.order_item_id ? { ...product, received_quantity: product.quantity, new_quantity: 0 } : product,
      );
      const allProductsFullyReceived = updatedMergedProducts.every((product) => {
        const totalReceived = (product.received_quantity || 0) + (product.new_quantity || 0);
        return totalReceived >= product.quantity;
      });
      const remainingQuantity = productData.quantity - (productData.old_quantity || 0);
      updateProductInOrder(productData.product_id, remainingQuantity, "new_quantity", productData, productData.product_request_id, productData.system_id, productData.phase_id);
      let successMessage = response.data.message;
      if (allProductsFullyReceived) successMessage = "Order status updated to Received successfully";
      else if (!allProductsFullyReceived) successMessage = "Order status set to Partially Received successfully";
      if (showPartialWarning) setShowPartialWarning(false);
      setShowFullReceivedModal(false);
      setSelectedProductForReceive(null);
      setAlert({ message: successMessage, type: "success", show: true, alertFor: "order-add" });
      setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);
      await getOrder();
      await getOrderProducts(orderPagination.pageIndex, orderPagination.pageSize, orderGlobalFilter);
    } catch (err) {
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "order-add");
    } finally {
      setShowReceivePopover(null);
      setIsConfirmingReceive(false);
    }
  };

  const [isReceivingAll, setIsReceivingAll] = useState(false);
  const [rackValidationErrors, setRackValidationErrors] = useState({});

  const [showGlobalFullReceivedModal, setShowGlobalFullReceivedModal] = useState(false);

  const handleReceiveAllInFull = async (forceExec = false) => {
    const allProducts = [...backendOrderProducts, ...newlyImportedProducts].filter(
      (p) => p.order_item_id && (p.received_quantity || 0) < p.quantity,
    );
    if (allProducts.length === 0) return;

    const productsNeedingAttention = allProducts.filter((p) => {
      const needsSerial = p.inventory_type?.toLowerCase() === "serial" || p.inventory_type === "Serial Number";
      const needsRack = rackOptions.length > 0 && !p.rack_id && !p.default_bin_id;
      return needsSerial || needsRack;
    });

    if (productsNeedingAttention.length > 0) {
      setRackValidationErrors({}); 
      const modalItems = productsNeedingAttention.map((p) => ({
        orderItemId: p.order_item_id,
        productId: p.product_id,
        productName: p.name,
        quantity: p.quantity,
        newQuantity: p.quantity - (p.received_quantity || 0),
        job_name: p.job_name,
        system_name: p.system_name,
        phase_name: p.phase_name,
        warehouse_name: p.warehouse_name,
        warehouse_id: p.warehouse_id,
        rack_id: p.rack_id || p.default_bin_id || null,
        rack_name: p.rack_name || "",
        rack_number: p.rack_number || "",
        row_number: p.row_number || "",
        column_number: p.column_number || "",
        inventory_type: p.inventory_type,
        product_request_id: p.product_request_id,
        job_id: p.job_id,
        system_id: p.system_id,
        phase_id: p.phase_id,
      }));

      setSerialItems(modalItems);
      setPendingSerialUpdate({ type: "receiveAll", products: allProducts });
      setActivePanel("serial");
      return;
    }

    if (!forceExec) {
      setShowGlobalFullReceivedModal(true);
      return;
    }

    setShowGlobalFullReceivedModal(false);
    setIsReceivingAll(true);
    try {
      await axios.put(
        `${url.backendURL}order/${id}/receive-all`,
        { serialNumbers: {}, racks: {} },
        { headers: { Authorization: `${token}` } },
      );
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setAlert({ message: "All products marked as received successfully", type: "success", show: true, alertFor: "order-add" });
      setTimeout(() => setAlert({ show: false, alertFor: "", message: "", type: "" }), 5000);
      await getOrder();
      await getOrderProducts(orderPagination.pageIndex, orderPagination.pageSize, orderGlobalFilter);
    } catch (err) {
      if (alertRef.current) alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "order-add");
    } finally {
      setIsReceivingAll(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => { if (showReceivePopover) setShowReceivePopover(null); };
    const scrollContainers = document.querySelectorAll(".MuiTableContainer-root, .modal-body, [data-simplebar]");
    scrollContainers.forEach((container) => container.addEventListener("scroll", handleScroll));
    window.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainers.forEach((container) => container.removeEventListener("scroll", handleScroll));
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showReceivePopover]);

  useEffect(() => {
    if (alert.show && alertRefProduct.current) {
      alertRefProduct.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [alert.show]);

  const [showFullReceivedModal, setShowFullReceivedModal] = useState(false);
  const [selectedProductForReceive, setSelectedProductForReceive] = useState(null);
  const [activeRowInput, setActiveRowInput] = useState(false);

  const submitRates = async (newRates, orderItemId, setIsSubmittingRates, setSuccessRatesLoader, setRateValue, setErrorRatesLoader, isSubmittingRates, cell) => {
    if (isSubmittingRates) return;
    if (orderItemId) {
      try {
        setIsSubmittingRates(true);
        await axios.put(`${url.backendURL}order/${id}/item/${orderItemId}/field`, { rate: newRates }, { headers: { Authorization: `${token}` } });
        setIsSubmittingRates(false);
        setSuccessRatesLoader(true);
        setOldOrderProducts((prev) => prev.map((data) => orderItemId === data.order_item_id ? { ...data, rate: newRates } : data));
        setTimeout(() => setSuccessRatesLoader(false), 5000);
      } catch (err) {
        if (alertRefProduct.current) alertRefProduct.current.scrollIntoView({ behavior: "smooth", block: "start" });
        handleError(err, "order-add");
        setRateValue(cell.getValue() || "");
        setErrorRatesLoader(true);
        setIsSubmittingRates(false);
      }
    }
  };

  const [draggingRowProduct, setDraggingRowProduct] = useState(null);
  const [hoveredTableProduct, setHoveredTableProduct] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const hoverTimeoutRef = useRef(null);
  const [rowHoverPopoverOpen, setRowHoverPopoverOpen] = useState(false);
  const [rowHoverPopoverAnchor, setRowHoverPopoverAnchor] = useState(null);

  const EditableRateCell = ({ cell, row }) => {
    const productId = cell.row.original.product_id;
    const productRequestId = cell.row.original.product_request_id;
    const systemId = cell.row.original.system_id;
    const phaseId = cell.row.original.phase_id;
    const orderItemId = cell.row.original.order_item_id;
    const rate = cell.getValue();
    const { quantity, old_quantity } = cell.row.original;
    const [rateValue, setRateValue] = useState(rate?.toString() || "");
    const [isSubmittingRates, setIsSubmittingRates] = useState(false);
    const [successRatesLoader, setSuccessRatesLoader] = useState(false);
    const [errorRatesLoader, setErrorRatesLoader] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);

    const handleChange = (e) => {
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1").replace(/^0+(\d)/, "$1");
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1 && value.length - decimalIndex > 3) value = value.slice(0, decimalIndex + 3);
      setRateValue(value);
    };

    const handleBlur = async () => {
      const trimmedValue = rateValue.trim();
      if (String(trimmedValue) !== String(rate ?? "")) {
        const newRate = parseFloat(trimmedValue || 0);
        if (cell.row.original.isNewlyImported && !orderItemId) {
          setNewlyImportedProducts((prev) =>
            prev.map((item) =>
              createProductKey(item) === createProductKey(cell.row.original)
                ? { ...item, rate: newRate, amount: newRate * (item.quantity || 1) }
                : item,
            ),
          );
        } else {
          await submitRates(newRate, orderItemId, setIsSubmittingRates, setSuccessRatesLoader, setRateValue, setErrorRatesLoader, isSubmittingRates, cell);
          updateProductInOrder(productId, newRate, "rate", row.original, productRequestId, systemId, phaseId);
        }
        setShowSuccessMessage(true);
        setTimeout(() => { setSuccessRatesLoader(false); setErrorRatesLoader(false); setShowSuccessMessage(false); }, 3000);
      }
      setFocused(false);
    };

    return (
      <Box sx={{ width: "100%" }}>
        <TextField
          type="text" inputRef={inputRef} value={rateValue} onChange={handleChange} onBlur={handleBlur} onFocus={() => { setFocused(true); setShowSuccessMessage(false); }}
          size="small" variant="outlined"
          disabled={(!hasImportUpdatePermission && decodedToken?.roles?.some((role) => role.role_type !== roleTypes.SUPER_ADMIN)) || (orderItemId ? (quantity === old_quantity) : false) || (cell.row.original.isNewlyImported ? false : !orderItemId) || isSubmittingRates || orderStatusCancelled || orderStatusReceived}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: successRatesLoader ? "2px solid #198754 !important" : errorRatesLoader ? "2px solid #d91111ff !important" : focused ? "2px solid #3b82f6" : "1px solid rgba(0, 0, 0, 0.23)" },
              "&:hover fieldset": { border: successRatesLoader ? "2px solid #198754 !important" : errorRatesLoader ? "2px solid #d91111ff !important" : "2px solid #3b82f6" },
              "&.Mui-focused fieldset": { border: successRatesLoader ? "2px solid #198754 !important" : errorRatesLoader ? "2px solid #d91111ff !important" : "2px solid #3b82f6 !important" },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isSubmittingRates ? <RotatingLines strokeWidth="5" animationDuration="0.75" width="15" strokeColor="#b2b4b9" visible={true} /> : successRatesLoader ? <Check style={{ color: "#198754", width: "20px", height: "20px" }} /> : errorRatesLoader ? <X style={{ color: "#d91111ff", width: "20px", height: "20px" }} /> : null}
              </InputAdornment>
            ),
          }}
        />
        {showSuccessMessage && !focused && <Box sx={{ mt: 0.5, display: "flex", justifyContent: "center" }}><Typography variant="caption" sx={{ color: "success.main", fontSize: "0.7rem", fontWeight: 500 }}>Rate updated successfully</Typography></Box>}
        {errorRatesLoader && !focused && <Box sx={{ mt: 0.5, display: "flex", justifyContent: "center" }}><Typography variant="caption" sx={{ color: "error.main", fontSize: "0.7rem", fontWeight: 500 }}>Failed to update rate</Typography></Box>}
        {validationErrors && typeof validationErrors === "object" && (() => {
          const productKey = createProductKey({ product_id: productId, product_request_id: productRequestId, job_id: cell.row.original.job_id, system_id: systemId, phase_id: phaseId });
          return validationErrors[productKey]?.rate && <Box sx={{ mt: 0.5 }}><Typography variant="caption" sx={{ fontSize: "0.75rem", color: "error.main" }}>{validationErrors[productKey].rate}</Typography></Box>;
        })()}
      </Box>
    );
  };

  const LocationCell = ({ cell, row }) => {
    const rackId = cell.getValue();
    const orderItemId = row.original.order_item_id;
    const hasError = rackValidationErrors[orderItemId];
    const currentRack = rackOptions.find((o) => o.value === rackId);

    if (orderStatusReceived || orderStatusCancelled) {
      return (
        <div className="d-flex align-items-center gap-2">
          {row.original.default_bin_id ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <span style={{ fontSize: "0.78rem", fontWeight: 500 }}>
                {row.original.rack_name} - {row.original.rack_number}
              </span>
              <span style={{ fontSize: "0.7rem", opacity: 0.8 }}>
                (R{row.original.row_number}C{row.original.column_number})
              </span>
            </div>
          ) : (
            <span className="text-muted fst-italic" style={{ fontSize: "0.8rem" }}>
              No Location
            </span>
          )}
        </div>
      );
    }

    return (
      <div
        className="d-flex align-items-center gap-2"
        style={{ cursor: "pointer", minWidth: "170px" }}
        onClick={() => {
          const wId = row.original.warehouse_id || row.original.warehouseId;
          fetchRackOptions(wId);
          setSelectedRackOrderItem(row.original);
          setShowRackBinModal(true);
        }}
      >
        {row.original.default_bin_id ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "0.85rem", color: "#333", fontWeight: 500 }}>
              {row.original.rack_name} - {row.original.rack_number}
            </span>
            <span style={{ fontSize: "0.75rem", color: "#666" }}>
              (R{row.original.row_number}C{row.original.column_number})
            </span>
          </div>
        ) : (
          <div className="d-flex flex-column">
            <span style={{ 
              fontSize: "0.85rem", 
              color: hasError ? "#dc3545" : "#aaa", 
              fontStyle: hasError ? "normal" : "italic",
              fontWeight: hasError ? 600 : 400
            }}>
              Select Location
            </span>
            {hasError && (
              <span style={{ color: "#dc3545", fontSize: "0.68rem", fontWeight: 500 }}>
                {rackValidationErrors[orderItemId]}
              </span>
            )}
          </div>
        )}
        <IconButton size="small" sx={{ padding: "2px", color: hasError ? "#dc3545" : "inherit" }}>
          <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="14px" width="14px" xmlns="http://www.w3.org/2000/svg">
            <path d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.47 513.5 0.5 502.53 2.1 487.26l12.6-114.14L290.74 93.24zM432.14 26.16c14.65-14.65 38.39-14.65 53.04 0l.66.66c14.65 14.65 14.65 38.39 0 53.04l-31.06 31.06L326.75 12.91l31.06-31.06a37.5 37.5 0 0174.33 24.31z"></path>
          </svg>
        </IconButton>
      </div>
    );
  };

  const productOrderColumns = useMemo(
    () => [
      {
        accessorKey: "quantity", header: "Quantity", size: 150,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral || !row.original.isNewlyImported) return <span style={{ fontSize: "0.85rem" }}>{row.original.quantity || 1}</span>;

          const p = row.original;
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.quantity;
          return (
            <>
              <TextField
                type="number" size="small" value={p.quantity ?? ""}
                inputProps={{ min: 0, max: 99999 }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "") {
                    setNewlyImportedProducts((prev) => prev.map((item) =>
                      item.product_id === p.product_id && item.job_id === p.job_id && item.system_id === p.system_id && item.phase_id === p.phase_id && !item.product_request_id
                        ? { ...item, quantity: "" } : item,
                    ));
                    return;
                  }
                  const n = parseInt(val, 10);
                  if (!isNaN(n) && n >= 0 && n <= 99999) {
                    setNewlyImportedProducts((prev) => prev.map((item) =>
                      item.product_id === p.product_id && item.job_id === p.job_id && item.system_id === p.system_id && item.phase_id === p.phase_id && !item.product_request_id
                        ? { ...item, quantity: n, amount: (parseFloat(item.rate) || 0) * n } : item,
                    ));
                  }
                }}
                sx={{ width: "80px" }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      { accessorKey: "old_quantity", header: "Received Quantity", size: 220, Cell: ReceivedQuantityCell },

      {
        accessorKey: "rack_id",
        header: "Location",
        size: 210,
        Cell: LocationCell,
      },

      { accessorKey: "manufacturer_name", header: "Make", size: 150 },
      { accessorKey: "model", header: "Model", size: 150 },
      { accessorFn: (row) => row.description || "", id: "description", header: "Description", size: 150 },
      { accessorKey: "sku", header: "SKU", size: 150 },
      { accessorKey: "rate", header: "Rate", size: 150, Cell: (props) => <EditableRateCell {...props} /> },
      { accessorKey: "amount", header: "Amount", size: 150 },
      {
        accessorKey: "job_name", header: "Job", size: 150,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral || !row.original.isNewlyImported) return <span style={{ fontSize: "0.85rem" }}>{row.original.job_name || ""}</span>;
          const p = row.original;
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.jobId;
          return (
            <>
              <Select
                options={gpOptionsJob}
                value={gpOptionsJob.find((o) => o.value === p.job_id) || null}
                onChange={async (opt) => {
                  const newJobId = opt?.value || null;
                  const newJobName = opt?.label || "";
                  const newSiteName = opt?.siteName || "";
                  setNewlyImportedProducts((prev) => prev.map((item) => {
                    if (createProductKey(item) === createProductKey(p) && item.isNewlyImported && !item.product_request_id) {
                      const updated = { ...item, job_id: newJobId, job_name: newJobName, site_name: newSiteName, system_id: null, system_name: "", phase_id: null, phase_name: "" };
                      updated.searchable_text = generateSearchableText(updated);
                      return updated;
                    }
                    return item;
                  }));
                  if (newJobId) {
                    const jd = await fetchJobSystemsPhases(newJobId);
                    if (jd?.active_system_id && jd?.active_phase_id) {
                      setNewlyImportedProducts((prev) => prev.map((item) => {
                        if (createProductKey(item) === createProductKey(p) && item.job_id === newJobId && item.isNewlyImported && !item.product_request_id) {
                          let sName = "", pName = "";
                          if (jd.systems) {
                            const sys = jd.systems.find((s) => s.system_id === jd.active_system_id);
                            if (sys) {
                              sName = sys.system_name;
                              if (sys.phases) {
                                const ph = sys.phases.find((ph) => ph.phase_id === jd.active_phase_id);
                                if (ph) pName = ph.phase_name;
                              }
                            }
                          }
                          const updated = { ...item, system_id: jd.active_system_id, system_name: sName, phase_id: jd.active_phase_id, phase_name: pName };
                          updated.searchable_text = generateSearchableText(updated);
                          return updated;
                        }
                        return item;
                      }));
                    }
                  }
                }}
                isClearable placeholder="Select Job"
                menuPortalTarget={document.body} menuPosition="fixed" menuPlacement="auto"
                styles={{ container: (b) => ({ ...b, width: "170px", border: err ? "1px solid red" : b.border }), option: (b, s) => ({ ...b, backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff", color: "#333", fontSize: "0.8rem" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }), menu: (b) => ({ ...b, zIndex: 9999 }) }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        accessorKey: "system_name", header: "System", size: 150,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral || !row.original.isNewlyImported) return <span style={{ fontSize: "0.85rem" }}>{row.original.system_name || ""}</span>;
          const p = row.original;
          const sysOpts = p.job_id && jobSystemsPhasesMap[p.job_id] ? jobSystemsPhasesMap[p.job_id].systems.map((s) => ({ value: s.system_id, label: s.system_name })) : [];
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.systemId;
          return (
            <>
              <Select
                options={sysOpts} value={sysOpts.find((o) => o.value === p.system_id) || null}
                isDisabled={!p.job_id}
                onChange={(opt) => {
                  const newSysId = opt?.value || null;
                  const newSysName = opt?.label || "";
                  setNewlyImportedProducts((prev) => prev.map((item) => {
                    if (createProductKey(item) === createProductKey(p) && item.isNewlyImported && !item.product_request_id) {
                      const updated = { ...item, system_id: newSysId, system_name: newSysName, phase_id: null, phase_name: "" };
                      updated.searchable_text = generateSearchableText(updated);
                      return updated;
                    }
                    return item;
                  }));
                }}
                isClearable placeholder={!p.job_id ? "Select job first" : "Select System"}
                menuPortalTarget={document.body} menuPosition="fixed" menuPlacement="auto"
                styles={{ container: (b) => ({ ...b, width: "180px", border: err ? "1px solid red" : b.border }), option: (b, s) => ({ ...b, backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff", color: "#333", fontSize: "0.8rem" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }), menu: (b) => ({ ...b, zIndex: 9999 }), placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }) }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        accessorKey: "phase_name", header: "Phase", size: 150,
        Cell: ({ row }) => {
          const isGeneral = !row.original.product_request_id;
          if (!isGeneral || !row.original.isNewlyImported) return <span style={{ fontSize: "0.85rem" }}>{row.original.phase_name || ""}</span>;
          const p = row.original;
          const phaseOpts = p.job_id && p.system_id && jobSystemsPhasesMap[p.job_id]
            ? (jobSystemsPhasesMap[p.job_id].systems.find((s) => s.system_id === p.system_id)?.phases || []).map((ph) => ({ value: ph.phase_id, label: ph.phase_name }))
            : [];
          const k = createProductKey(p);
          const err = validationErrors?.[k]?.phaseId;
          return (
            <>
              <Select
                options={phaseOpts} value={phaseOpts.find((o) => o.value === p.phase_id) || null}
                isDisabled={!p.system_id}
                onChange={(opt) => {
                  const newPhaseId = opt?.value || null;
                  const newPhaseName = opt?.label || "";
                  setNewlyImportedProducts((prev) => prev.map((item) => {
                    if (createProductKey(item) === createProductKey(p) && item.isNewlyImported && !item.product_request_id) {
                      const updated = { ...item, phase_id: newPhaseId, phase_name: newPhaseName };
                      updated.searchable_text = generateSearchableText(updated);
                      return updated;
                    }
                    return item;
                  }));
                }}
                isClearable placeholder={!p.system_id ? "Select system first" : "Select Phase"}
                menuPortalTarget={document.body} menuPosition="fixed" menuPlacement="auto"
                styles={{ container: (b) => ({ ...b, width: "180px", border: err ? "1px solid red" : b.border }), option: (b, s) => ({ ...b, backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff", color: "#333", fontSize: "0.8rem" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }), menu: (b) => ({ ...b, zIndex: 9999 }), placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }) }}
              />
              {err && <div className="small text-danger mt-1">{err}</div>}
            </>
          );
        }
      },
      {
        accessorKey: "requested_product", header: "Requested Product", size: 100,
        Cell: ({ row }) => {
          if (!row.original.isNewlyImported) return null;
          return <span style={{ fontSize: "0.85rem" }}>{row.original.product_request_id ? "Yes" : "No"}</span>;
        }
      },
      { accessorKey: "warehouse_name", header: "Warehouse", size: 150 },
      { accessorKey: "searchable_text", header: "Searchable Text", size: 0, enableHiding: true, enableColumnFilter: false, enableGlobalFilter: true, muiTableHeadCellProps: { sx: { display: "none" } }, muiTableBodyCellProps: { sx: { display: "none" } } },
      { accessorKey: "site_name", header: "Site Name", size: 150 },
      {
        accessorKey: "action", header: "Action", size: 150,
        Cell: ({ row }) => {
          const { product_request_id, product_id, system_id, phase_id, quantity, old_quantity, isNewlyImported } = row.original;
          const uniqueId = `edit-${product_request_id}-${product_id}-${system_id}-${phase_id}`;
          return (
            <div className="d-flex justify-content-start align-items-center gap-1">
              <Link
                className={`btn btn-sm btn-icon btn-success ${row?.original?.isNewlyImported ? "opacity-50" : "opacity-100"}`}
                onClick={(e) => { e.preventDefault(); handleProductView(e, row.original); }} title="View"
              >
                <span className="btn-inner"><IoEyeOutline style={{ width: "20px", height: "20px" }} /></span>
              </Link>
   
              {!row.original?.order_item_id && row.original.isNewlyImported && (
                <Link>
                  <Tooltip title="Remove">
                    <IconButton
                      size="medium" color="error"
                      className={`${row?.original?.isNewlyImported || orderStatusCancelled || orderStatusReceived ? "opacity-50" : "opacity-100"}`}
                      disabled={orderStatusReceived || orderStatusCancelled}
                      onClick={async (e) => {
                        e.preventDefault();
                        if (isNewlyImported && !orderStatusCancelled && !orderStatusReceived) {
                          const productKey = createProductKey(row.original);
                          const isFromRequest = !!row.original.product_request_id;
                          setNewlyImportedProducts((prev) => {
                            const newList = prev.filter((item) => createProductKey(item) !== productKey);
                            if (showGeneralProductsPanel) {
                              gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction, [...newList, ...backendOrderProducts]);
                            }
                            if (isFromRequest) {
                              setProducts((old) => old.map((p) => createProductKey(p) === productKey ? { ...p, moved: false, isSelected: false } : p));
                              getActiveProductRequests(pagination.pageIndex, pagination.pageSize, globalFilter);
                            }
                            return newList;
                          });
                        }
                      }}
                    >
                      <CancelIcon fontSize="medium" />
                    </IconButton>
                  </Tooltip>
                </Link>
              )}
            </div>
          );
        },
      },
    ].filter((col) => !(fromReceiveInFull && col.accessorKey === "requested_product")),
    [activeRows, validationErrors, orderStatusCancelled, orderStatusReceived, gpOptionsJob, bulkSystemOptions, bulkPhaseOptions, jobSystemsPhasesMap, newlyImportedProducts, rackOptions, rackValidationErrors, fromReceiveInFull],
  );

  const generalProductColumns = useMemo(
    () => [
      {
        id: "gpSelect", size: 50, enableSorting: false,
        Header: () => {
          const allSel = gpProducts.length > 0 && gpProducts.every((p) => gpIsInSelection(p.productId, p.systemId, p.phaseId));
          return (
            <Checkbox
              checked={allSel && !gpLoadingInitial}
              disabled={gpLoadingInitial || gpLoadingSystems}
              onChange={(e) => {
                if (e.target.checked) {
                  const newOnes = gpProducts.filter((p) => !gpIsInSelection(p.productId, p.systemId, p.phaseId));
                  setGpSelectedProducts((prev) => [...prev, ...newOnes.map((p) => ({ ...p, quantity: p.quantity || 1, rate: p.rate || 0, amount: (p.rate || 0) * (p.quantity || 1) }))]);
                } else {
                  const keys = gpProducts.map((p) => gpCreateKey(p.productId, p.systemId, p.phaseId));
                  setGpSelectedProducts((prev) => prev.filter((p) => !keys.includes(gpCreateKey(p.productId, p.systemId, p.phaseId))));
                }
              }}
            />
          );
        },
        Cell: ({ row }) => {
          const p = row.original;
          if (p.isLoadMoreRow) {
            return (
              <div style={{ position: "sticky", left: "0", right: "0", width: "fit-content", margin: "0 auto", display: "flex", justifyContent: "center", pointerEvents: "none", zIndex: 10, backgroundColor: "white" }}>
                <div style={{ pointerEvents: "auto", padding: "15px 0" }}>
                  <button type="button" className="btn btn-outline-primary px-4 py-2" onClick={() => gpLoadMore()} disabled={gpLoadingMore}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#3a57e8"; e.currentTarget.style.color = "#fff"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "white"; e.currentTarget.style.color = "#3a57e8"; }}
                    style={{ borderRadius: "20px", fontWeight: "400", fontSize: "14px", minWidth: "160px" }}>
                    {gpLoadingMore ? (<><span className="spinner-border spinner-border-sm me-2" />Loading...</>) : (<><i className="fas fa-plus-circle me-2" />Load More</>)}
                  </button>
                </div>
              </div>
            );
          }
          const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
          const k = gpCreateKey(p.productId, p.systemId, p.phaseId);
          const hasErr = Object.keys(gpValidationErrors[k] || {}).length > 0;
          return <Checkbox checked={isSel} disabled={gpLoadingInitial || gpLoadingSystems} sx={hasErr && isSel ? { color: "red" } : {}} onChange={() => gpSelectRow(p, false)} />;
        },
      },
      { accessorKey: "quantity", header: "Qty", size: 100, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.quantity || 1}</span> },
      { accessorKey: "manufacturerName", header: "Make", size: 140, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.manufacturerName || ""}</span> },
      { accessorKey: "model", header: "Model", size: 130, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.model || ""}</span> },
      {
        accessorKey: "description", header: "Description", size: 180,
        Cell: ({ row }) => {
          const p = row.original;
          if (p.isLoadMoreRow) return null;
          const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
          if (isSel) return <TextField size="small" value={p.description || ""} InputProps={{ readOnly: true }} sx={{ width: "160px", "& .MuiInputBase-input": { cursor: "not-allowed", fontSize: "0.8rem" } }} />;
          return <span style={{ fontSize: "0.85rem" }}>{p.description || ""}</span>;
        },
      },
      { accessorKey: "sku", header: "SKU", size: 130, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.sku || ""}</span> },
      { accessorKey: "rate", header: "Rate", size: 130, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.rate || 0}</span> },
      { accessorKey: "amount", header: "Amount", size: 110, Cell: ({ row }) => row.original.isLoadMoreRow ? null : <span style={{ fontSize: "0.85rem" }}>{row.original.amount ?? 0}</span> },
      {
        id: "gpAction", header: "Action", size: 70,
        Cell: ({ row }) => {
          if (row.original.isLoadMoreRow) return null;
          return (
            <Link className="btn btn-sm btn-icon btn-success" onClick={(e) => { e.preventDefault(); setGpViewItem(row.original); setGpViewModal(true); }} title="View">
              <span className="btn-inner"><IoEyeOutline style={{ width: "20px", height: "20px" }} /></span>
            </Link>
          );
        },
      },
    ],
    [gpProducts, gpSelectedProducts, gpValidationErrors, gpOptionsJob, gpLoadingInitial, gpLoadingSystems, gpLoadingMore, gpNextOffset, gpTotal, jobSystemsPhasesMap],
  );

  const gpTableData = useMemo(() => {
    if (!gpLoadingInitial && gpNextOffset !== null && gpNextOffset < gpTotal) {
      return [...gpProducts, { id: "GP_LOAD_MORE_FAKE_ID", isLoadMoreRow: true }];
    }
    return gpProducts;
  }, [gpProducts, gpLoadingInitial, gpNextOffset, gpTotal]);

  const animatedMoveProduct = async (product, isMultiple = false) => {
    const productKey = createProductKey(product);
    setAnimatingRows((prev) => new Set([...prev, productKey]));
    setMovingProducts((prev) => new Set([...prev, productKey]));
    await new Promise((resolve) => setTimeout(resolve, 500));
    setTimeout(() => {
      setAnimatingRows((prev) => { const s = new Set(prev); s.delete(productKey); return s; });
      setMovingProducts((prev) => { const s = new Set(prev); s.delete(productKey); return s; });
    }, 400);
  };

  const tableGeneralProduct = useMaterialReactTable({
    columns: generalProductColumns,
    data: gpTableData,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    enableRowDragging: true,
    enableRowSelection: false,
    enablePagination: false,
    enableBottomToolbar: false,
    getRowId: (originalRow) => gpCreateKey(originalRow.productId, originalRow.systemId, originalRow.phaseId),
    muiRowDragHandleProps: ({ row }) => ({
      title: "Drag to move",
      onDragStart: () => {
        setRowHoverPopoverOpen(false); setRowHoverPopoverAnchor(null); setHoveredRowId(null);
        if (hoverTimeoutRef.current) { clearTimeout(hoverTimeoutRef.current); hoverTimeoutRef.current = null; }
      },
      onDragEnd: async () => {
        if (hoveredTableProduct === "order-product") {
          const p = draggingRowProduct.original;
          const k = gpCreateKey(p.productId, p.systemId, p.phaseId);
          const isSel = gpSelectedProducts.some((item) => gpCreateKey(item.productId, item.systemId, item.phaseId) === k);
          if (isSel) {
            if (gpValidate()) {
              const toAdd = [...gpSelectedProducts];
              setGpSelectedProducts([]);
              handleAddGeneralProductsToOrder(toAdd);
              await Promise.all(toAdd.map((data) => animatedMoveProduct(data, true)));
            }
          } else {
            const errs = {};
            let hasErr = false;
            if (!p.quantity || p.quantity <= 0) { errs[gpCreateKey(p.productId, p.systemId, p.phaseId)] = { quantity: "Quantity is required" }; hasErr = true; }
            if (!p.rate || parseFloat(p.rate) <= 0) { errs[gpCreateKey(p.productId, p.systemId, p.phaseId)] = { ...errs[gpCreateKey(p.productId, p.systemId, p.phaseId)], rate: "Rate must be greater than 0" }; hasErr = true; }
            if (hasErr) { setGpValidationErrors(errs); }
            else { handleAddGeneralProductsToOrder([p]); await animatedMoveProduct(p); }
          }
        }
        setHoveredTableProduct(null);
      },
      sx: { cursor: row.original.isLoadMoreRow ? "default" : "grab", opacity: row.original.isLoadMoreRow ? 0 : 1 },
    }),
    muiTableBodyCellProps: ({ cell, row }) => {
      if (row.original.isLoadMoreRow) {
        if (cell.column.id === "gpSelect") {
          return { colSpan: 15, sx: { display: "block", position: "sticky", width: "100%", left: "45%", bottom: 0, padding: "0", borderBottom: "none", zIndex: 10, backgroundColor: "white", height: "70px", boxShadow: "0px -4px 10px rgba(0,0,0,0.05)" } };
        }
        return { sx: { display: "none" } };
      }
      return {};
    },
    muiTableBodyRowProps: ({ row }) => {
      const p = row.original;
      if (p.isLoadMoreRow) return { sx: { cursor: "default" } };
      const productKey = gpCreateKey(p.productId, p.systemId, p.phaseId);
      const isSel = gpIsInSelection(p.productId, p.systemId, p.phaseId);
      const hasErr = isSel && Object.keys(gpValidationErrors[productKey] || {}).length > 0;
      return {
        onClick: async (e) => {
          if (["INPUT", "BUTTON", "A", "TEXTAREA", "SELECT"].includes(e.target.tagName) || e.target.closest(".MuiCheckbox-root") || e.target.closest(".MuiTableDragHandle-root")) return;
          if (isSel) {
            if (gpValidate()) {
              const toAdd = [...gpSelectedProducts];
              setGpSelectedProducts([]);
              handleAddGeneralProductsToOrder(toAdd);
              await Promise.all(toAdd.map((data) => animatedMoveProduct(data, true)));
            }
          } else {
            const errs = {};
            let hasErrors = false;
            if (!p.quantity || p.quantity <= 0) { errs[productKey] = { quantity: "Quantity is required" }; hasErrors = true; }
            if (p.rate === "" || p.rate === null || p.rate === undefined) { errs[productKey] = { ...errs[productKey], rate: "Rate is required" }; hasErrors = true; }
            if (hasErrors) { setGpValidationErrors(errs); }
            else { handleAddGeneralProductsToOrder([p]); await animatedMoveProduct(p); }
          }
        },
        sx: { backgroundColor: isSel ? "#ecf2f9c2" : "inherit", outline: hasErr ? "2px solid red" : "none", cursor: "pointer", "&:hover": { backgroundColor: isSel ? "#ddeeff" : "rgba(33,108,220,0.05)" } },
      };
    },
    enableGlobalFilter: true, manualFiltering: true,
    onGlobalFilterChange: setGpSearchText,
    onDraggingRowChange: setDraggingRowProduct,
    enableTopToolbar: true,
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
    state: { isLoading: gpLoadingInitial, globalFilter: gpSearchText, draggingRow: draggingRowProduct },
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("general-product"),
      sx: { outline: hoveredTableProduct === "general-product" ? "2px dashed #216CDC" : undefined, width: "100%", minWidth: "100%", overflow: "visible" },
    },
  });

  const getAllSelectedProducts = () => Array.from(selectedProductsData.values());

  const commonTableProps = {
    autoResetPageIndex: false,
    enableRowDragging: true,
    enableColumnFilter: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    onDraggingRowChange: setDraggingRowProduct,
    state: { draggingRow: draggingRowProduct, isLoading: loadingProducts, pagination, globalFilter },
    manualPagination: true, manualFiltering: true,
    onPaginationChange: setPagination, onGlobalFilterChange: setGlobalFilter,
    rowCount: totalRecords,
  };

  const tableProduct = useMaterialReactTable({
    ...commonTableProps,
    columns: productColumns,
    data: products,
    enableColumnFilters: false,
    defaultColumn: { size: 100 },
    getRowId: (originalRow) => createProductKey(originalRow),
    muiRowDragHandleProps: ({ row }) => ({
      title: row.original.status === "in-active" || row.original.moved ? "Cannot move this item" : "Drag to move",
      onDragStart: () => {
        setRowHoverPopoverOpen(false); setRowHoverPopoverAnchor(null); setHoveredRowId(null);
        if (hoverTimeoutRef.current) { clearTimeout(hoverTimeoutRef.current); hoverTimeoutRef.current = null; }
      },
      onDragEnd: async () => {
        if (hoveredTableProduct === "order-product") {
          const p = draggingRowProduct.original;
          const draggedKey = createProductKey(p);
          const isDraggedRowSelected = selectedProductKeys.has(draggedKey);
          if (isDraggedRowSelected) {
            const selectedProductsToMove = getAllSelectedProducts();
            if (selectedProductsToMove && selectedProductsToMove.length > 0) {
              const newProducts = selectedProductsToMove.map((product) => {
                const item = { ...product, isSelected: false, new_quantity: 0, old_quantity: product.received_quantity || 0, received_quantity: 0, isNewlyImported: true, phase_name: product.phase_name || product.phaseNames || "", searchable_text: product.searchable_text || "" };
                item.searchable_text = generateSearchableText(item);
                return item;
              });
              setNewlyImportedProducts((prev) => [...newProducts, ...(Array.isArray(prev) ? prev : [])]);
              setProducts((prev) => prev.map((product) => { const key = createProductKey(product); return selectedProductKeys.has(key) ? { ...product, moved: true, isSelected: false } : product; }));
              setSelectedProductKeys(new Set()); setSelectedProductsData(new Map());
              await Promise.all(selectedProductsToMove.map((data) => animatedMoveProduct(data, true)));
            }
          } else {
            const newProduct = { ...draggingRowProduct.original, isSelected: false, new_quantity: 0, old_quantity: draggingRowProduct.original.received_quantity || 0, received_quantity: 0, isNewlyImported: true, phase_name: draggingRowProduct.original.phase_name || draggingRowProduct.original.phaseNames || "", searchable_text: draggingRowProduct.original.searchable_text || "" };
            newProduct.searchable_text = generateSearchableText(newProduct);
            setNewlyImportedProducts((prev) => [newProduct, ...(Array.isArray(prev) ? prev : [])]);
            setProducts((prev) => prev.map((product) => createProductKey(product) === draggedKey ? { ...product, moved: true } : product));
            await animatedMoveProduct(draggingRowProduct.original);
          }
          resetPaginationToFirst();
        } else if (hoveredTableProduct === "product") {
          const p = draggingRowProduct.original;
          if (p.isNewlyImported) {
            const productKey = createProductKey(p);
            setNewlyImportedProducts((prev) => {
              const newList = prev.filter((item) => createProductKey(item) !== productKey);
              if (showGeneralProductsPanel) { gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction, [...newList, ...backendOrderProducts]); }
              return newList;
            });
          }
        }
        setHoveredTableProduct(null);
      },
      sx: { cursor: row.original.status === "in-active" || row.original.moved ? "not-allowed" : "grab", opacity: row.original.status === "in-active" || row.original.moved ? 0.3 : 1, transition: "all 0.2s ease" },
    }),
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("product"),
      sx: { outline: hoveredTableProduct === "product" ? "2px dashed #216CDC" : undefined, width: "100%", minWidth: "100%", minHeight: "100px", overflow: "visible", position: "relative", zIndex: 0 },
    },
    muiTableBodyRowProps: ({ row }) => {
      const productKey = createProductKey(row.original);
      const isMoved = row.original.moved;
      const isInactive = row.original.status === "in-active";
      const canMove = !isInactive && !isMoved;
      return {
        onMouseEnter: (event) => {
          if (hoverTimeoutRef.current) { clearTimeout(hoverTimeoutRef.current); hoverTimeoutRef.current = null; }
          if (!canMove) { setRowHoverPopoverOpen(false); setRowHoverPopoverAnchor(null); setHoveredRowId(null); return; }
          setHoveredRowId(productKey);
          hoverTimeoutRef.current = setTimeout(() => { setRowHoverPopoverAnchor(event.currentTarget); setMousePosition({ x: event.clientX, y: event.clientY }); setRowHoverPopoverOpen(true); }, 50);
        },
        onMouseMove: (event) => { if (canMove && rowHoverPopoverOpen && hoveredRowId === productKey) setMousePosition({ x: event.clientX, y: event.clientY }); },
        onMouseLeave: () => {
          if (hoverTimeoutRef.current) { clearTimeout(hoverTimeoutRef.current); hoverTimeoutRef.current = null; }
          if (hoveredRowId === productKey) { hoverTimeoutRef.current = setTimeout(() => { setRowHoverPopoverOpen(false); setRowHoverPopoverAnchor(null); setHoveredRowId(null); }, 100); }
        },
        onClick: async (e) => {
          if (e.target.closest("input[type='checkbox']") || e.target.closest(".MuiTableDragHandle-root") || e.target.closest("svg")) return;
          if (row.original.status !== "in-active" && !row.original.moved) {
            const clickedKey = createProductKey(row.original);
            const isClickedRowSelected = selectedProductKeys.has(clickedKey);
            if (isClickedRowSelected) {
              const selectedProductsToMove = getAllSelectedProducts();
              if (selectedProductsToMove && selectedProductsToMove.length > 0) {
                const newProducts = selectedProductsToMove.map((product) => ({ ...product, isSelected: false, new_quantity: 0, old_quantity: product.received_quantity || 0, received_quantity: 0, isNewlyImported: true }));
                setNewlyImportedProducts((prev) => [...newProducts, ...(Array.isArray(prev) ? prev : [])]);
                setProducts((prev) => prev.map((product) => { const key = createProductKey(product); return selectedProductKeys.has(key) ? { ...product, moved: true, isSelected: false } : product; }));
                setSelectedProductKeys(new Set()); setSelectedProductsData(new Map());
              }
            } else {
              const newProduct = { ...row.original, isSelected: false, new_quantity: 0, old_quantity: row.original.received_quantity || 0, received_quantity: 0, isNewlyImported: true, phase_name: row.original.phase_name || row.original.phaseNames || "", searchable_text: row.original.searchable_text || "" };
              newProduct.searchable_text = generateSearchableText(newProduct);
              setNewlyImportedProducts((prev) => [newProduct, ...(Array.isArray(prev) ? prev : [])]);
              setProducts((prev) => prev.map((product) => createProductKey(product) === clickedKey ? { ...product, moved: true } : product));
            }
            await animatedMoveProduct(row.original);
            resetPaginationToFirst();
          }
        },
        sx: {
          backgroundColor: row.original.status === "in-active" ? "#bcb8b8" : row.original.moved ? "#216CDC" : "inherit",
          pointerEvents: row.original.status === "in-active" ? "none" : "auto",
          cursor: row.original.status === "in-active" ? "no-drop" : "pointer",
          "&:hover": { backgroundColor: row.original.status !== "in-active" && !row.original.moved ? "rgba(33, 109, 220, 0.1)" : undefined },
        },
      };
    },
    renderEmptyRowsFallback: () => (
      <div className={`${!isTable3Open ? "align-items-center justify-content-center" : "align-items-start justify-content-start ps-5"}`}
        style={{ position: "sticky", bottom: "0", left: "30%", width: "100%", display: "flex", backgroundColor: "white", padding: "3rem 0", zIndex: 10 }}>
        <div className={`text-muted ${!isTable3Open && "ps-5"}`}>
          <i className="fas fa-search fa-3x mb-3 opacity-50" />
          No products have been added yet. &nbsp;
          {!isTable3Open && <><a style={{ color: "#007bff", cursor: "pointer" }} onClick={() => setActivePanel("requested")}>Add some products</a>&nbsp; to continue.</>}
        </div>
      </div>
    ),
    muiBottomToolbarProps: { className: "compact-pagination-toolbar" },
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
  });

  const tableOrderProduct = useMaterialReactTable({
    columns: productOrderColumns,
    data: enhancedOrderProducts,
    enableRowDragging: false,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableFilterMatchHighlighting: false,
    muiTableContainerProps: { sx: { minHeight: "60vh", maxHeight: "60vh" } },
    onDraggingRowChange: (row) => setDraggingRowProduct(row),
    getRowId: (originalRow) => `order-${createProductKey(originalRow)}`,
    state: { draggingRow: draggingRowProduct, isLoading: loadingOrderProducts, pagination: orderPagination, globalFilter: orderGlobalFilter },
    manualPagination: true,
    manualFiltering: false,
    onPaginationChange: setOrderPagination,
    onGlobalFilterChange: (val) => { setOrderGlobalFilter(val); setOrderPagination((prev) => ({ ...prev, pageIndex: 0 })); },
    rowCount: totalOrderRecords,
    globalFilterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.trim() === "") return true;
      const searchWords = filterValue.toLowerCase().replace(/[-+]/g, " ").replace(/\s+/g, " ").trim().split(/\s+/);
      const searchableText = (row.original.searchable_text || "").toLowerCase();
      const backupText = [row.original.name, row.original.productName, row.original.manufacturerName].filter(Boolean).join(" ").toLowerCase();
      return searchWords.every((word) => searchableText.includes(word) || backupText.includes(word));
    },
    muiRowDragHandleProps: {
      onDragEnd: () => {
        if (hoveredTableProduct === "product") {
          const draggedKey = createProductKey(draggingRowProduct.original);
          const isFromRequest = !!draggingRowProduct.original.product_request_id;
          let newNewlyImported = newlyImportedProducts;
          if (draggingRowProduct.original.isNewlyImported) {
            newNewlyImported = newlyImportedProducts.filter((item) => createProductKey(item) !== draggedKey);
            setNewlyImportedProducts(newNewlyImported);
          } else {
            setBackendOrderProducts((prev) => prev.filter((item) => createProductKey(item) !== draggedKey));
          }
          if (showGeneralProductsPanel) { gpLoadInitial(gpSearchText, gpSortConfig.key, gpSortConfig.direction, [...newNewlyImported, ...backendOrderProducts]); }
          if (isFromRequest) {
            setProducts((old) => old.map((p) => createProductKey(p) === draggedKey ? { ...p, moved: false, isSelected: false } : p));
            getActiveProductRequests(pagination.pageIndex, pagination.pageSize, globalFilter);
          }
        }
        setHoveredTableProduct(null);
      },
    },
    muiTablePaperProps: {
      onDragEnter: () => setHoveredTableProduct("order-product"),
      sx: { outline: hoveredTableProduct === "order-product" ? "2px dashed #216CDC" : undefined, position: "relative", overflow: "visible" },
    },
    muiTableBodyRowProps: ({ row }) => {
      const lastNewlyImportedProduct = enhancedOrderProducts?.filter((item) => item.isNewlyImported).pop();
      const isNewlyImported = row.original.isNewlyImported;
      const isLastNewlyImported = isNewlyImported && createProductKey(row.original) === createProductKey(lastNewlyImportedProduct || {});
      const productKey = createProductKey(row.original);
      const isNewlyAdded = movingProducts.has(productKey);
      return {
        sx: {
          backgroundColor: isNewlyImported ? "#ecf2f9c2" : "inherit",
          ...(isLastNewlyImported && { borderBottom: "2px solid #d1d7dccc", boxShadow: "0px 6px 13px #d1d7dccc, 0px 12px 18px #d1d7dccc" }),
          position: "relative",
          ...(isNewlyAdded && { transform: "translateX(0)", opacity: 1, transition: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)", backgroundColor: "#216ddc1a" }),
        },
      };
    },
    renderEmptyRowsFallback: () => {
      const isSearchActive = orderGlobalFilter && orderGlobalFilter.trim() !== "";
      return (
        <div className={`${!isTable3Open ? "align-items-center justify-content-center" : "align-items-start justify-content-start ps-5"}`}
          style={{ position: "sticky", bottom: "0", left: "30%", width: "100%", display: "flex", backgroundColor: "white", padding: "3rem 0", zIndex: 10 }}>
          <div className={`text-muted ${!isTable3Open && "ps-5"}`}>
            <i className={`fas ${isSearchActive ? "fa-search-minus" : "fa-search"} fa-3x mb-3 opacity-50`} />
            <div style={{ fontSize: "1.1rem", fontWeight: 500 }}>
              {isSearchActive ? (
                <>No products match your search </>
              ) : (
                <>No products have been added yet.&nbsp;
                  {!isRightPanelOpen && <><a style={{ color: "#007bff", cursor: "pointer" }} onClick={() => setActivePanel("requested")}>Add some products</a>&nbsp; to continue.</>}
                </>
              )}
            </div>
          </div>
        </div>
      );
    },
    muiBottomToolbarProps: { className: "compact-pagination-toolbar" },
    muiTopToolbarProps: { className: "compact-pagination-topbar" },
  });

  const [showTooltip, setShowTooltip] = useState(false);
  const popupRef = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setShowTooltip(true);
      const hideTimer = setTimeout(() => setShowTooltip(false), 2000);
      return () => clearTimeout(hideTimer);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const buttonContainerStyle = { position: "relative", cursor: "pointer", display: "inline-block" };
  const buttonStyle = { position: "relative", overflow: "hidden", borderRadius: "0.75rem", backgroundColor: "white", padding: "1rem 1.5rem", border: "none", outline: "none", transition: "transform 0.3s ease", transform: isHovered ? "scale(1.05)" : "scale(1)", boxShadow: isHovered ? "0 10px 25px rgba(0,0,0,0.1)" : "0 5px 15px rgba(0,0,0,0.08)" };
  const beforeStyle = { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, border: "2px solid transparent", background: "linear-gradient(45deg, #22348b, #344ed0, #4d67ea, #3a57e8)", backgroundSize: "300% 300%", borderRadius: "0.75rem", zIndex: -2, animation: "gradientMove 4s ease infinite" };
  const afterStyle = { position: "absolute", top: "2px", left: "2px", right: "2px", bottom: "2px", backgroundColor: "white", borderRadius: "10px", zIndex: -1 };
  const contentStyle = { position: "relative", zIndex: 10, display: "flex", alignItems: "center", gap: "0.75rem" };
  const textStyle = { fontWeight: "400", fontSize: "0.90rem", color: "#000", margin: 0 };
  const chevronStyle = { width: "1.15rem", height: "1.15rem", color: "#1215ca", transition: "transform 0.3s ease", transform: isTable3Open ? "rotate(270deg)" : "rotate(90deg)" };
  const tooltipStyle = { position: "absolute", bottom: "calc(100% + 10px)", left: "50%", transform: "translateX(-50%)", backgroundColor: "#1f2937", color: "white", padding: "0.5rem 0.75rem", borderRadius: "6px", fontSize: "0.8rem", fontWeight: "500", whiteSpace: "nowrap", zIndex: 1000, opacity: showTooltip && !isTable3Open ? 1 : 0, visibility: showTooltip && !isTable3Open ? "visible" : "hidden", transition: "all 0.3s ease", boxShadow: "0 4px 12px rgba(0,0,0,0.2)" };
  const tooltipArrowStyle = { position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: "6px solid #1f2937" };

  const handleCloseView = async () => setItemViewModel(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResetForm = async (resetForm) => {
    setNewlyImportedProducts([]);
    setSelectedProductKeys(new Set());
    setSelectedProductsData(new Map());
    resetForm();
    setHasUnsavedChanges(false);
    setActivePanel("none");
    await getActiveProductRequests(pagination.pageIndex, pagination.pageSize, globalFilter);
  };

  return (
    <>
      <div>
        <Modal show={showFullReceivedModal} onHide={() => { setShowFullReceivedModal(false); setSelectedProductForReceive(null); }} backdrop="static" keyboard={true} centered>
          <Modal.Header className="custom-modal-header d-flex relative">
            <Modal.Title>Confirm Full Received</Modal.Title>
            <button type="button" className="btn-close-svg" style={{ position: "absolute", right: "1rem" }} onClick={() => { setShowFullReceivedModal(false); setSelectedProductForReceive(null); }} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
            </button>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted mb-3" style={{ fontSize: "1rem", lineHeight: "1.5" }}>Are you sure all items in this product have been received? This action will mark the product as received</p>
            {selectedProductForReceive && (
              <div className="text-start mb-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                <p className="mb-1"><strong>Product: </strong>{selectedProductForReceive.name}</p>
                <p className="mb-0"><strong>Quantity: </strong>{selectedProductForReceive.quantity}</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="btn btn-primary" disabled={isConfirmingReceive} onClick={(e) => { if (selectedProductForReceive) handleFullReceived(e, selectedProductForReceive); }}>
              {isConfirmingReceive ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Processing...</>) : (<><i className="fas fa-check me-2" style={{ fontSize: "0.8rem" }} />Confirm</>)}
            </Button>
            <Button variant="btn btn-danger" onClick={() => { setShowFullReceivedModal(false); setSelectedProductForReceive(null); }}>Cancel</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showGlobalFullReceivedModal} onHide={() => setShowGlobalFullReceivedModal(false)} backdrop="static" keyboard={true} centered>
          <Modal.Header className="custom-modal-header d-flex relative">
            <Modal.Title>Confirm Received in Full</Modal.Title>
            <button type="button" className="btn-close-svg" style={{ position: "absolute", right: "1rem" }} onClick={() => setShowGlobalFullReceivedModal(false)} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
            </button>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted mb-3" style={{ fontSize: "1rem", lineHeight: "1.5" }}>
              Are you sure you want to mark <strong>all products</strong> in this order as received in full? This action cannot be undone.
            </p>
            <div className="text-start mb-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
              <p className="mb-0">
                <strong>Pending Items: </strong>
                {[...backendOrderProducts, ...newlyImportedProducts].filter((p) => p.order_item_id && (p.received_quantity || 0) < p.quantity).length}
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="btn btn-primary" disabled={isReceivingAll} onClick={() => handleReceiveAllInFull(true)}>
              {isReceivingAll ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Processing...</>) : (<><i className="fas fa-check me-2" style={{ fontSize: "0.8rem" }} />Confirm</>)}
            </Button>
            <Button variant="btn btn-danger" onClick={() => setShowGlobalFullReceivedModal(false)}>Cancel</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDiscardModal} onHide={handleCancelDiscard} backdrop="static" keyboard={false} centered>
          <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
            <Modal.Title>Unsaved Changes</Modal.Title>
            <button type="button" className="btn-close-svg" style={{ position: "absolute", right: "1rem" }} onClick={handleCancelDiscard} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
            </button>
          </Modal.Header>
          <Modal.Body className="text-center px-4 pt-2">
            <p className="text-muted mb-4 px-2" style={{ fontSize: "1rem", lineHeight: "1.5" }}>You have unsaved changes to this order. Do you want to discard these changes?</p>
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
            <Button type="button" className="btn btn-white me-4" variant="btn btn-white" onClick={handleDiscardChanges} style={{ borderRadius: "25px", fontWeight: "500", minWidth: "100px", borderColor: "#6c757d", color: "#6c757d" }}>Discard</Button>
            <Button className="px-4 py-2" style={{ backgroundColor: "#3a57e8", borderColor: "#3a57e8", borderRadius: "25px", fontWeight: "500", minWidth: "100px" }} onClick={handleCancelDiscard}>Continue</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={itemViewModel} onHide={handleCloseView} backdrop="true" keyboard={true} size="lg">
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Item</Modal.Title>
            <button type="button" className="btn-close-svg" onClick={handleCloseView} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
            </button>
          </Modal.Header>
          <Formik initialValues={itemView} enableReinitialize>
            {({ values, handleChange }) => (
              <Form className="form-horizontal ps-3 pe-3">
                <FocusError />
                <Modal.Body>
                  <Row><Col sm="6"><Form.Group><Form.Label>Description</Form.Label><Form.Control readOnly type="text" value={values?.description || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>Make</Form.Label><Form.Control readOnly type="text" value={values?.manufacturer_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm="6"><Form.Group><Form.Label>Model</Form.Label><Form.Control readOnly type="text" value={values?.model || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>SKU</Form.Label><Form.Control readOnly type="text" value={values?.sku || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm="6"><Form.Group><Form.Label>System</Form.Label><Form.Control readOnly type="text" value={values?.system_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>Phase</Form.Label><Form.Control readOnly type="text" value={values?.phase_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm="6"><Form.Group><Form.Label>Warehouse</Form.Label><Form.Control readOnly type="text" value={values?.warehouse_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>Job</Form.Label><Form.Control readOnly type="text" value={values?.job_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm={12}><Form.Group><Form.Label>Description</Form.Label><Form.Control readOnly as="textarea" value={values?.description || ""} onChange={handleChange} style={{ resize: "none", fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm="6"><Form.Group><Form.Label>Quantity</Form.Label><Form.Control type="text" readOnly value={values?.quantity ?? ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>Rate</Form.Label><Form.Control type="text" readOnly value={values?.rate || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                  <Row><Col sm="6"><Form.Group><Form.Label>Amount</Form.Label><Form.Control type="text" readOnly value={values?.amount || 0} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group><Form.Label>Job</Form.Label><Form.Control type="text" readOnly value={values?.job_name || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        </Modal>

        <Modal show={gpViewModal} onHide={() => { setGpViewModal(false); setGpViewItem(null); }} backdrop="true" keyboard={true} size="lg" style={{ zIndex: 99999 }}>
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Product</Modal.Title>
            <button type="button" className="btn-close-svg" onClick={() => { setGpViewModal(false); setGpViewItem(null); }} aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
            </button>
          </Modal.Header>
          <Modal.Body>
            {gpViewItem && (
              <>
                <Row><Col sm="6"><Form.Group className="form-group"><Form.Label>Description</Form.Label><Form.Control readOnly type="text" value={gpViewItem.description || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group className="form-group"><Form.Label>Make</Form.Label><Form.Control readOnly type="text" value={gpViewItem.manufacturerName || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                <Row><Col sm="6"><Form.Group className="form-group"><Form.Label>Model</Form.Label><Form.Control readOnly type="text" value={gpViewItem.model || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group className="form-group"><Form.Label>SKU</Form.Label><Form.Control readOnly type="text" value={gpViewItem.sku || ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                <Row><Col sm="12"><Form.Group className="form-group"><Form.Label>Description</Form.Label><Form.Control readOnly as="textarea" value={gpViewItem.description || ""} style={{ resize: "none", fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                <Row><Col sm="6"><Form.Group className="form-group"><Form.Label>Quantity</Form.Label><Form.Control readOnly type="text" value={gpViewItem.quantity ?? ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col><Col sm="6"><Form.Group className="form-group"><Form.Label>Rate</Form.Label><Form.Control readOnly type="text" value={gpViewItem.rate ?? ""} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
                <Row><Col sm="6"><Form.Group className="form-group"><Form.Label>Amount</Form.Label><Form.Control readOnly type="text" value={gpViewItem.amount ?? 0} style={{ fontSize: "0.8rem", cursor: "not-allowed" }} /></Form.Group></Col></Row>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Formik enableReinitialize={true} initialValues={{ ...selectedData }} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ values, handleChange, handleBlur, touched, setFieldValue, handleSubmit, isSubmitting, resetForm, errors: errorsFormik, setFieldError, setFieldTouched }) => (
            <Form onSubmit={handleSubmit}>
              <FocusError />
              <Row>
                <Col xl="12" lg="12" ref={alertRef}>
                  <Card>
                    <Card.Header className="d-flex justify-content-between">
                      <div className="breadcrumb header-title" style={{ cursor: "pointer" }}>
                        <h4 onClick={() => navigate("/dashboard/app/purchase-order-list")} className="text-primary card-title" style={{ cursor: "pointer" }}><span>Purchase Order </span></h4>
                        <h4 className="mx-2 card-title"> {">"} </h4>
                        <h4 className="card-title"> Edit </h4>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      {!loader ? (
                        <>
                          <Row className="mb-4 new-order-info">
                            <Col md={8} className="d-flex align-items-end">
                              <Row md={12} style={{ width: "100%" }}>
                                <Col md={4}>
                                  <DatePickerField
                                    className="col-md-12" name="date" placeholder="MM/DD/YYYY" value={selectedData?.date} label="Date" asterick={true}
                                    disabled={orderStatusReceived || orderStatusCancelled || fromReceiveInFull} errorMessage={errors?.date}
                                    onAutoSubmit={async (formattedDate) => {
                                      setFieldSubmit("date");
                                      if (formattedDate) await handleSubmitOrderDetail("date", formattedDate);
                                      else { setFailOrderDetailSubmit("date"); setTimeout(() => setFailOrderDetailSubmit(null), 2000); }
                                    }}
                                    isSubmitting={fieldSubmit === "date"} submitSuccess={successOrderDetailSubmit === "date"} submitFail={failOrderDetailSubmit === "date"}
                                  />
                                </Col>
                                <Col md={4}>
                                  <InputField className="col-md-12 form-group" type="text" name="poNumber" disabled={true || fromReceiveInFull} placeholder="Enter PO Number" value={values.poNumber} asterick={true} errorMessage={errors?.poNumber} label="PO #" />
                                </Col>
                                <Col md={4}>
                                  <Form.Group className="col-md-12 form-group">
                                    <Form.Label>Vendor <span className="text-danger">*</span></Form.Label>
                                    <Select
                                      options={optionsVendorForPO} isDisabled={orderStatusReceived || orderStatusCancelled || fromReceiveInFull}
                                      value={optionsVendorForPO.find((option) => option.value === values.vendorId)}
                                      onChange={async (option) => {
                                        setFieldValue("vendorId", option?.value || null);
                                        if (option?.value) { setFieldSubmit("vendorId"); await handleSubmitOrderDetail("vendorId", option?.value); }
                                      }}
                                      isClearable placeholder="Select Vendor" menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({ ...base, height: "45px", borderColor: successOrderDetailSubmit === "vendorId" ? "green" : failOrderDetailSubmit === "vendorId" || !values.vendorId ? "red" : base.borderColor }),
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="col-md-12 form-group">
                                <Form.Label className="d-flex" style={{ whiteSpace: "nowrap" }}>
                                  Ship To
                                  <span className="d-flex flex-row" style={{ width: "100%" }}>
                                    <span className="text-danger">* </span>
                                    <Select
                                      options={warehouseOptions} isDisabled={orderStatusReceived || orderStatusCancelled || fromReceiveInFull}
                                      value={warehouseOptions.find((option) => option.value === values.warehouseId)}
                                      onChange={async (option) => {
                                        const selectedWarehouse = warehouseOptions.find((warehouse) => warehouse.value === option?.value);
                                        setWarehouseId(option?.value);
                                        setSelectedData((prev) => ({ ...prev, warehouseId: option?.value }));
                                        setFieldValue("warehouseId", option?.value);
                                        const newShipTo = selectedWarehouse?.address || values.shipTo;
                                        setFieldValue("shipTo", newShipTo);
                                        setSelectedData((prev) => ({ ...prev, shipTo: newShipTo }));
                                        if (option?.value) {
                                          setFieldError("warehouseId", undefined); setFieldTouched("warehouseId", false);
                                          setFieldSubmit("warehouseId");
                                          await handleSubmitOrderDetail("warehouseId", option?.value, { shipTo: newShipTo });
                                          if (newShipTo) { setFieldError("shipTo", undefined); setFieldTouched("shipTo", false); }
                                          setErrors((prevErrors) => { const newErrors = { ...prevErrors }; delete newErrors.warehouseId; delete newErrors.shipTo; return newErrors; });
                                        } else {
                                          setFieldError("warehouseId", "Warehouse is required"); setFieldTouched("warehouseId", true);
                                          setFailOrderDetailSubmit("warehouseId"); setTimeout(() => setFailOrderDetailSubmit(null), 2000);
                                        }
                                      }}
                                      isClearable
                                      placeholder={warehouseOptions.length === 0 ? <span>No warehouse found</span> : "Select Warehouse..."}
                                      noOptionsMessage={() => (
                                        <div style={{ textAlign: "center", justifyContent: "center" }}>
                                          <span style={{ color: "#666" }}>No warehouse found.
                                            {(warehouseHasCreatePermission || decodedToken?.roles.some((role) => role.role_type === roleTypes.SUPER_ADMIN)) && (
                                              <span> <Link to="/dashboard/app/warehouse-add" style={{ color: "#007bff", textDecoration: "none" }}>Add new</Link></span>
                                            )}
                                          </span>
                                        </div>
                                      )}
                                      menuPortalTarget={document.body} menuPosition="fixed" menuPlacement="auto" className="display-content-dropdown"
                                      styles={{
                                        option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e6f7ff" : "#fff", color: "#333", width: "100%" }),
                                        control: (provided) => ({
                                          ...provided, marginLeft: "1rem", width: "100%", color: "#5e667b",
                                          borderColor: successOrderDetailSubmit === "warehouseId" ? "green" : failOrderDetailSubmit === "warehouseId" || (touched.warehouseId && errorsFormik.warehouseId) ? "red" : provided.borderColor,
                                          boxShadow: successOrderDetailSubmit === "warehouseId" ? "0 0 5px green" : failOrderDetailSubmit === "warehouseId" || (touched.warehouseId && errorsFormik.warehouseId) ? "0 0 5px red" : provided.boxShadow,
                                        }),
                                        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                      }}
                                    />
                                    {fieldSubmit === "warehouseId" && (
                                      <div style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
                                        <RotatingLines strokeWidth="5" animationDuration="0.75" width="20" strokeColor="#b2b4b9" visible={true} />
                                      </div>
                                    )}
                                  </span>
                                </Form.Label>
                                <ErrorMessage name="warehouseId" component="div" className="text-danger text-end" />
                                {errors?.warehouseId?.map((error, index) => <span key={index} className="w-100 mt-1 small text-danger">{error}<br /></span>)}
                                <div style={{ position: "relative" }}>
                                  <Form.Control
                                    id="shipTo" as="textarea" type="text" name="shipTo" disabled={orderStatusReceived || orderStatusCancelled || fromReceiveInFull}
                                    placeholder="Enter Shipment Address" value={values?.shipTo} onChange={handleChange}
                                    onBlur={async (e) => {
                                      handleBlur(e); setFieldSubmit("shipTo");
                                      if (e.target.value && e.target.value.trim()) await handleSubmitOrderDetail("shipTo", e.target.value, { warehouseId: values.warehouseId });
                                      else { setFailOrderDetailSubmit("shipTo"); setTimeout(() => setFailOrderDetailSubmit(null), 2000); }
                                    }}
                                    style={{ resize: "none", height: "150px", borderColor: successOrderDetailSubmit === "shipTo" ? "green" : failOrderDetailSubmit === "shipTo" ? "red" : "#dee2e6", boxShadow: successOrderDetailSubmit === "shipTo" ? "0 0 5px green" : failOrderDetailSubmit === "shipTo" ? "0 0 5px red" : "none" }}
                                  />
                                  {fieldSubmit === "shipTo" && (
                                    <div style={{ position: "absolute", top: "10px", right: "10px", pointerEvents: "none" }}>
                                      <RotatingLines strokeWidth="5" animationDuration="0.75" width="20" strokeColor="#b2b4b9" visible={true} />
                                    </div>
                                  )}
                                </div>
                                <ErrorMessage name="shipTo" component="div" className="text-danger" />
                                {errors?.shipTo?.map((error, index) => <span key={index} className="w-100 mt-1 small text-danger">{error}<br /></span>)}
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={12} ref={alertRefProduct}>
                              <Card>
                                <Card.Body>
                                  <Row className="m-0 p-0">
                                    <Col md={12} className="m-0 p-0">
                                      { showPartialWarning && !orderStatusReceived && (
                                        <Alert variant="info" className="d-flex align-items-center justify-items-center">
                                          <span>To set an order to <strong>partially received</strong>, you must mark at least one product as <strong>full</strong> or <strong>partially received</strong>.</span>
                                          <button type="button" className="btn-close ms-auto" data-bs-dismiss="alert" aria-label="Close" onClick={() => setShowPartialWarning(false)} />
                                        </Alert>
                                      )}

                                      {!orderStatusReceived && !orderStatusCancelled && !checkReceivedQuantity() && !fromReceiveInFull && (
                                        <Col xs={12} className="d-flex gap-4 flex-column flex-md-row justify-content-end mb-3">
                                          <Button
                                            variant="primary" className="text-nowrap d-flex align-items-center gap-2"
                                            onClick={() => setActivePanel((prev) => prev === "general" ? "none" : "general")}
                                            style={{ borderRadius: "0.5rem" }}
                                          >
                                            {showGeneralProductsPanel ? (
                                              <span>Hide New Products</span>
                                            ) : (
                                              <><Plus style={{ width: "16px", height: "16px" }} /><span>Add New Products</span></>
                                            )}
                                          </Button>

                                          <div
                                            style={buttonContainerStyle}
                                            onClick={() => setActivePanel((prev) => prev === "requested" ? "none" : "requested")}
                                            ref={popupRef}
                                            onMouseEnter={() => setIsHovered(true)}
                                            onMouseLeave={() => setIsHovered(false)}
                                          >
                                            <div style={buttonStyle}>
                                              <div style={beforeStyle} />
                                              <div style={afterStyle} />
                                              <div style={contentStyle}>
                                                {!isTable3Open && <Plus className="text-primary" style={{ width: "1.25rem", height: "1.25rem" }} />}
                                                <span style={textStyle}>{isTable3Open ? "Hide Requested Products" : "Show Requested Products"}</span>
                                                <ChevronDown className="text-primary" style={chevronStyle} />
                                              </div>
                                            </div>
                                            <div style={tooltipStyle}>
                                              Click here to add products to this order
                                              <div style={tooltipArrowStyle} />
                                            </div>
                                          </div>

                                          <style>{`
                                            @keyframes gradientMove { 0%,100%{background-position:0% 50%} 25%{background-position:100% 50%} 50%{background-position:100% 100%} 75%{background-position:0% 100%} }
                                          `}</style>
                                        </Col>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row className="d-flex" ref={containerRef} style={{ flexDirection: isMobile ? "column" : "row", flexWrap: isMobile ? "wrap" : "nowrap", position: "relative" }}>
                                    <Col
                                      md="auto" sm={12} className="m-0 p-0"
                                      style={{
                                        width: isMobile ? "100%" : isRightPanelOpen ? `calc(${leftWidth}% - 5px)` : "100%",
                                        transition: isResizing ? "none" : "width 0.5s ease-in-out",
                                        flex: isMobile ? "1 1 auto" : "0 0 auto",
                                      }}
                                    >
                                      <Card.Header className="d-flex flex-column ps-0">
                                        <div className="header-title w-100 mb-3">
                                          <h5 className="card-title">Order Products</h5>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                          {(backendOrderProducts.length > 0 || newlyImportedProducts.length > 0) && !orderStatusReceived && !location.state?.fromStatusChange && !orderStatusCancelled && (
                                            <Row className="mb-3 g-2 mt-2 flex-grow-1 me-3">
                                              <Col md={4} sm={12}>
                                                <Select
                                                  options={gpOptionsJob} value={gpOptionsJob.find((o) => o.value === bulkJobId) || null}
                                                  onChange={(opt) => { const newJobId = opt?.value || null; setBulkJobId(newJobId); setBulkSystemId(null); setBulkPhaseId(null); }}
                                                  isClearable placeholder="Select Job" menuPortalTarget={document.body}
                                                  styles={{ container: (b) => ({ ...b, width: "100%" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                                />
                                              </Col>
                                              <Col md={4} sm={12}>
                                                <Select
                                                  options={bulkSystemOptions} value={bulkSystemOptions.find((o) => o.value === bulkSystemId) || null}
                                                  onChange={(opt) => { const newSysId = opt?.value || null; setBulkSystemId(newSysId); setBulkPhaseId(null); }}
                                                  isClearable isDisabled={!bulkJobId} placeholder="Select System" menuPortalTarget={document.body}
                                                  styles={{ container: (b) => ({ ...b, width: "100%" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                                />
                                              </Col>
                                              <Col md={4} sm={12}>
                                                <Select
                                                  options={bulkPhaseOptions} value={bulkPhaseOptions.find((o) => o.value === bulkPhaseId) || null}
                                                  onChange={(opt) => { setBulkPhaseId(opt?.value || null); }}
                                                  isClearable isDisabled={!bulkSystemId} placeholder="Select Phase" menuPortalTarget={document.body}
                                                  styles={{ container: (b) => ({ ...b, width: "100%" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {!orderStatusReceived && !orderStatusCancelled && location.state?.fromStatusChange && (backendOrderProducts.some(p => p.received_quantity < p.quantity) || newlyImportedProducts.length > 0) && (
                                            <div className="ms-auto mb-3" style={{ flexShrink: 0 }}>
                                              <Button
                                                type="button" variant="success" disabled={isReceivingAll}
                                                onClick={handleReceiveAllInFull}
                                                className="text-nowrap d-flex align-items-center gap-2"
                                                style={{ borderRadius: "0.5rem", fontWeight: 600 }}
                                              >
                                                {isReceivingAll ? (
                                                  <><RotatingLines strokeWidth="5" animationDuration="0.75" width="16" strokeColor="white" visible={true} /><span>Processing...</span></>
                                                ) : (
                                                  <><Check style={{ width: "16px", height: "16px" }} /><span>Received in Full</span></>
                                                )}
                                              </Button>
                                          </div>
                                        )}
                                      </div>
                                      <AlertNotificationSimple type={alert.type} message={alert.message} show={alert.show} onClose={() => setAlert({ ...alert, show: false })} />
                                    </Card.Header>
                                      <Card.Body className="ps-0">
                                        {validationErrors && typeof validationErrors === "string" && <span className="w-100 mt-1 small text-danger">{validationErrors}<br /></span>}
                                        {validationErrors && typeof validationErrors === "object" && Object.keys(validationErrors).length > 0 && (
                                          <span className="w-100 mt-1 small text-danger d-block mb-2">Rate must be greater than 0<br /></span>
                                        )}
                                        <Box sx={{ pt: "4px", width: "100%", marginTop: "0rem" }}>
                                          <MaterialReactTable table={tableOrderProduct} />
                                          <div style={{ marginTop: "2rem" }} />
                                          <hr className="order-button" />
                                          <div className="order-button flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2" style={{ marginTop: "2rem" }}>
                                           {!location.state?.fromStatusChange &&
                                            <Button type="button" className="me-2 me-md-5 px-3 px-md-4" variant="btn btn-light" disabled={orderStatusReceived || orderStatusCancelled || newlyImportedProducts.length < 1} onClick={() => handleResetForm(resetForm)}>Reset</Button>
                                           }
                                            {!location.state?.fromStatusChange &&
                                            <Button type="submit" disabled={isSubmitting || orderStatusReceived || orderStatusCancelled || newlyImportedProducts.length < 1} variant="btn btn-primary" className="me-2 me-md-5 px-3 px-md-4">Submit</Button>
                                            }
                                            <Button type="button" className="px-3 px-md-4" variant="btn btn-danger" onClick={() => navigate("/dashboard/app/purchase-order-list")}>Cancel</Button>
                                          </div>
                                        </Box>
                                      </Card.Body>
                                    </Col>

                                    {!isMobile && isRightPanelOpen && (
                                      <Tooltip title="Drag left or right to resize tables" placement="top" arrow>
                                        <div
                                          onMouseDown={startResizing}
                                          style={{ width: "16px", cursor: "col-resize", zIndex: 10, flex: "0 0 auto", position: "relative", display: "flex", justifyContent: "center", alignItems: "center", background: isResizing ? "rgba(0,123,255,0.05)" : "transparent", transition: "background 0.3s" }}
                                          className="resizer-handle"
                                        >
                                          <div style={{ width: "1px", height: "78%", borderLeft: isResizing ? "2px solid #007bff" : "2px dotted #adb5bd", opacity: isResizing ? 1 : 0.6, transition: "all 0.3s", position: "absolute" }} />
                                          <div style={{ width: "16px", height: "40px", borderRadius: "4px", background: isResizing ? "#007bff" : "#fff", border: isResizing ? "1px solid #007bff" : "1px solid #adb5bd", zIndex: 11, display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", transition: "all 0.3s" }}>
                                            {[0, 1, 2].map((i) => <div key={i} style={{ width: "2px", height: "2px", borderRadius: "50%", background: isResizing ? "#fff" : "#adb5bd" }} />)}
                                          </div>
                                        </div>
                                      </Tooltip>
                                    )}

                                    <Col
                                      md="auto" sm={12} className="m-0 p-0"
                                      style={{
                                        width: isMobile ? isRightPanelOpen ? "100%" : "0%" : isRightPanelOpen ? `calc(${100 - leftWidth}% - 5px)` : "0%",
                                        height: isRightPanelOpen ? "auto" : "0px",
                                        opacity: isRightPanelOpen ? 1 : 0,
                                        transition: isResizing ? "none" : "width 0.5s ease-in-out, opacity 0.3s ease-in-out",
                                        overflow: "hidden",
                                        visibility: isRightPanelOpen ? "visible" : "hidden",
                                        maxWidth: isMobile ? "100%" : isRightPanelOpen ? `calc(${100 - leftWidth}% - 5px)` : "0%",
                                        flex: isMobile ? "1 1 auto" : "0 0 auto",
                                      }}
                                    >
                                      <div style={{ opacity: isRightPanelOpen ? 1 : 0, transform: isRightPanelOpen ? "translateX(0)" : "translateX(20px)", transition: "opacity 0.4s ease-in-out, transform 0.4s ease-in-out" }}>

                                        {activePanel === "requested" && (
                                          <>
                                            <Card.Header className="d-flex justify-content-between ps-0">
                                              <div className="header-title">
                                                <h5 className="card-title">Requested Products</h5>
                                                <p className="card-title">Drag product from here into order form</p>
                                              </div>
                                              <Col md={5} className="d-flex flex-row justify-content-end align-items-center mb-3">
                                                <Form.Label className="text-nowrap me-2 mt-1" style={{ fontSize: "16px" }}>Filter by </Form.Label>
                                                <Select
                                                  options={optionsVendor} value={optionsVendor.find((option) => option.value === vendorId)}
                                                  onChange={(option) => { setVendorId(option?.value || "all"); setPagination({ pageIndex: 0, pageSize: 5 }); }}
                                                  isClearable placeholder="Select Vendor"
                                                  styles={{
                                                    container: (provided) => ({ ...provided, width: "100%" }),
                                                    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e6f7ff" : "#fff", color: "#333", fontSize: "0.8rem" }),
                                                    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                                    placeholder: (provided) => ({ ...provided, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                                  }}
                                                />
                                              </Col>
                                            </Card.Header>
                                            <Card.Body className="ps-2 pe-0">
                                              <Box sx={{ py: "4px", width: "100%", whiteSpace: "nowrap", marginTop: "3.8rem" }}>
                                                <MaterialReactTable table={tableProduct} />
                                                <PopoverMui
                                                  open={dragPopoverOpen} anchorEl={dragPopoverAnchor} disableScrollLock disableAutoFocus disableEnforceFocus
                                                  onClose={() => setDragPopoverOpen(false)}
                                                  anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }}
                                                  sx={{ pointerEvents: "none" }}
                                                  PaperProps={{ sx: { px: 1.5, py: 0.5, backgroundColor: "#333", color: "white", fontSize: "0.75rem", borderRadius: "4px", boxShadow: "0px 4px 12px rgba(0,0,0,0.3)" } }}
                                                >
                                                  <Typography variant="caption">Drag to move</Typography>
                                                </PopoverMui>
                                                <PopoverMui
                                                  open={!dragPopoverOpen && rowHoverPopoverOpen} anchorEl={rowHoverPopoverAnchor}
                                                  disableScrollLock disableAutoFocus disableEnforceFocus disableRestoreFocus
                                                  onClose={() => { setRowHoverPopoverOpen(false); setRowHoverPopoverAnchor(null); setHoveredRowId(null); if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current); }}
                                                  anchorReference="anchorPosition" anchorPosition={{ top: mousePosition.y - 10, left: mousePosition.x }}
                                                  transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                  sx={{ pointerEvents: "none", "& .MuiPaper-root": { transform: "translateX(-50%)" } }}
                                                  PaperProps={{ sx: { px: 1.5, py: 0.5, backgroundColor: "#333", color: "white", fontSize: "0.75rem", borderRadius: "4px", boxShadow: "0px 4px 12px rgba(0,0,0,0.3)" } }}
                                                >
                                                  <Typography variant="caption">Click or drag to move</Typography>
                                                </PopoverMui>
                                              </Box>
                                            </Card.Body>
                                          </>
                                        )}

                                        {activePanel === "general" && (
                                          <div style={{ marginTop: "0.5rem" }}>
                                            <Card.Header className="d-flex justify-content-between align-items-start ps-0 pt-2 pb-3 flex-wrap gap-2">
                                              <div className="header-title">
                                                <h5 className="card-title">General Products List</h5>
                                                <p className="card-title">Drag product from here into order form</p>
                                              </div>
                                              <Col md={5} className="d-flex flex-row justify-content-end align-items-center mb-3">
                                                <Form.Label className="text-nowrap me-2 mt-1" style={{ fontSize: "16px" }}>Filter by </Form.Label>
                                                <Select
                                                  options={optionsVendor} value={optionsVendor.find((o) => o.value === vendorId)}
                                                  onChange={(option) => { setVendorId(option?.value || "all"); }}
                                                  isClearable placeholder="Select Vendor"
                                                  styles={{ container: (b) => ({ ...b, width: "100%" }), option: (b, s) => ({ ...b, backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff", color: "#333", fontSize: "0.8rem" }), menuPortal: (b) => ({ ...b, zIndex: 9999 }), menu: (b) => ({ ...b, zIndex: 9999 }) }}
                                                />
                                              </Col>
                                            </Card.Header>
                                            <Card.Body className="ps-0 pe-0 pt-0">
                                              <Box sx={{ width: "100%", overflow: "visible", "& .MuiToolbar-root": { minHeight: "auto !important", py: "8px" }, marginTop: "4.7rem" }}>
                                                <MaterialReactTable table={tableGeneralProduct} />
                                              </Box>
                                            </Card.Body>
                                          </div>
                                        )}

                                        {activePanel === "serial" && (
                                          <div className="h-100 overflow-hidden" style={{ marginTop: "0.5rem" }}>
                                            <SerialNumberPanel
                                              show={true}
                                              onHide={handleSerialCancel}
                                              onSubmit={handleSerialSubmit}
                                              serialItems={serialItems}
                                              rackOptions={rackOptions}
                                              title={
                                                pendingSerialUpdate?.type === "receiveAll"
                                                  ? "Receive All Items"
                                                  : serialItems.some((item) => !item.rack_id)
                                                    ? "Inventory Processing"
                                                    : "Enter Serial Numbers"
                                              }
                                              onOpenRackPicker={(item) => {
                                                const orderItemId = item.orderItemId ?? item.order_item_id;
                                                const fullRow = [...serialItems, ...backendOrderProducts, ...newlyImportedProducts].find(
                                                  (p) => (p.order_item_id || p.orderItemId) === orderItemId,
                                                ) || item;
                                                const wId = fullRow.warehouse_id || fullRow.warehouseId || item.warehouse_id || item.warehouseId;
                                                fetchRackOptions(wId);
                                                setSelectedRackOrderItem({
                                                  ...fullRow,
                                                  order_item_id: orderItemId,
                                                  product_id: item.productId ?? fullRow.product_id,
                                                  name: item.productName ?? fullRow.name,
                                                  rack_id: item.rack_id ?? fullRow.rack_id ?? null,
                                                  rack_id_parent: item.rack_id_parent ?? fullRow.rack_id_parent ?? null,
                                                  _fromSerialModal: true,
                                                });
                                                setShowRackBinModal(true);
                                              }}
                                            />
                                          </div>
                                        )}

                                      </div>
                                    </Col>
                                    <hr className="order-bottom-button" />
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Row>

                          <div className="order-bottom-button flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2">
                            <Button type="button" className="me-2 me-md-5 px-3 px-md-4" variant="btn btn-light" disabled={orderStatusReceived || orderStatusCancelled || newlyImportedProducts.length < 1} onClick={() => handleResetForm(resetForm)}>Reset</Button>
                            <Button type="submit" disabled={isSubmitting || orderStatusReceived || orderStatusCancelled || newlyImportedProducts.length < 1} variant="btn btn-primary" className="me-2 me-md-5 px-3 px-md-4">Submit</Button>
                            <Button type="button" className="px-3 px-md-4" variant="btn btn-danger" onClick={() => navigate("/dashboard/app/purchase-order-list")}>Cancel</Button>
                          </div>
                        </>
                      ) : (
                        loader && <FadeLoaderComponent />
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>

      {showRackBinModal && (() => {
        const currentItemId = selectedRackOrderItem?.order_item_id ?? selectedRackOrderItem?.orderItemId;
        const pendingBinIds = {};
        serialItems.forEach((item) => {
          const itemId = item.order_item_id ?? item.orderItemId;
          const binId = item.rack_id || item.default_bin_id;
          if (binId && itemId !== currentItemId) {
            pendingBinIds[String(binId)] = item.productName || item.name || "Another Product";
          }
        });
        return (
          <RackBinModal
            show={showRackBinModal}
            onHide={() => { setShowRackBinModal(false); setSelectedRackOrderItem(null); }}
            selectedRackOrderItem={selectedRackOrderItem}
            handleBinAssign={handleBinAssign}
            warehouseId={selectedRackOrderItem?.warehouse_id || selectedRackOrderItem?.warehouseId || warehouseId}
            token={token}
            decodedToken={decodedToken}
            pendingBinIds={pendingBinIds}
          />
        );
      })()}
    </>
  );
};

export default OrderRequestEdit;